import {defineComponent, nextTick} from 'vue';
import baseDetailPopup from './baseDetailPopup';
import {mapGetters, mapActions} from 'vuex';
import accountAPI from '@/apis/di/accountAPI.js';
import moment from 'moment';
import httpClient from '@/apis/base/httpclient';
import _ from 'lodash';
import {collectionMonitor} from '@/setup/utilities/monitor';
import {MSConstant} from '@/commons/wildcards/index.js';
import api from '@/apis/report/voucherReportPrintAPI';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import {
  ModuleLayout,
  ModuleContext,
  ModuleAccountParallelRule,
  ModuleAccountParallelRuleDetail,
  ModuleBudgetSource,
  ModuleSysAccountParallelVoucherListRule,
  ModuleSysAccountParallelVoucherListRuleDetail,
  ModuleAccountCombo,
  ModuleOfflineWork,
  ModuleDbOption,
} from '@/stores/moduleConst';
import {
  showError,
  showConfirm,
  showConfirmValidate,
  showConfirmValidateCustom,
  showConfirmAutoGenerateParallel,
  showConfirmGenerateParallel,
} from '@/commons/globalMessage';
import {printVoucherMenu} from '@/mixins/common/printVoucherMenu';
import {printVoucher} from '@/mixins/common/printVoucher';
import popupUtil from '@/commons/popupUtil';
import commonFunction from '@/commons/commonFunction';
import store from '@/stores/store';
import {exportDifferenceParallel} from '@/commons/acccountingParallel';
import IndexedDB from '@/commons/indexedDB';
import accountingObjectAPI from '@/apis/di/accountingObjectAPI.js';
import voucherReportPrintAPI from '@/apis/report/voucherReportPrintAPI';
import maintainDatabaseFn from '@/commons/validateMaintainDatabase.js';

export default defineComponent({
  extends: baseDetailPopup,
  name: 'BaseDetailVoucher',
  mixins: [printVoucher, printVoucherMenu],
  data: function () {
    const me = this;
    const dataRightClick = [
      {
        text: 'Thêm dòng',
        action: 'AddRow',
        isActive: true, // có trigger click vào cell nào ko
        classDisabled: '.noClick',
      },
      {
        text: 'Xóa dòng',
        action: 'DeleteRow',
        isActive: true,
        classDisabled: '.noClick',
      },
      {
        text: 'Xem số dư tài khoản',
        action: 'ViewAccount',
        isActive: false,
      },
    ];

    // Biến tính thuế theo PP nào
    const taxCalculationMethod = store.state[ModuleDbOption]?.dbOptions?.TaxCalculationMethod;

    return {
      editViewDefaultMode: me.$ms.constant.FormState.View,
      refDetail: 'refDetail',
      refDetailParallel: 'refDetailParallel',
      refDetailOther: 'refDetailOther',
      /**
       * Hiển thị hướng dẫn
       */
      showStep: false,
      /**
       * Biến lưu cell đầu tiên bị lỗi trên grid
       * NHANH3 08.05.2023
       */
      firstElementError: null,
      /**
       * Biến lưu thông tin cell đầu tiên bị lỗi trên grid (colIndex, rowIndex, col)
       * NHANH3 08.05.2023
       */
      infoElementError: {},
      /**
       * Biến kiểm tra xem thông tin master có bị lỗi không ?
       * NHANH3 08.05.2023
       */
      isMasterError: false,
      /**
       * Biến lưu kết quả check danh mục từ server
       * NHANH3 10.05.2023
       */
      resultCheckExist: null,

      /**
       * Biến lưu tên của chứng từ
       * NHANH3 18.04.2023
       */
      titleVoucher: '',
      /**
       * Vào từ màn đối chiếu chuyển đổi
       * nvtoan2 15/05/2023
       */
      isFromCompareConvert: false,
      /**
       * Biến lưu thông tin required khi ghi sổ
       * NHANH3 17.05.2023
       */
      invalidPost: null,

      /**
       * Biến lưu giá trị lỗi khi ghi sổ
       */
      cacheInvalidPosted: [],
      /**
       * Biến xác định enable/disable thông tin sửa nhanh
       * lhphong 26.05.2023
       */
      isQuickEditVoucher: false,
      /**
       * Biến lưu các giá trị invalid của detail khi validate ghi sổ để validate lại khi chuyển Tab detail
       * NHANH3 05.07.2023
       */
      invalidDetailPosted: null,

      // currentIndexNext: true,
      dataRightClick: dataRightClick,

      titleRefCode: null,

      /**
       * HMDUC2: Biến đánh dấu PP tính thuê
       */
      taxCalculationMethod: taxCalculationMethod,
    };
  },

  watch: {
    layoutTagDetail(newVal, oldVal) {
      const me = this;
      if (newVal !== oldVal) {
        //init layout
        this.initLayoutDetail();
        if (me.editMode == me.$ms.constant.FormState.Edit || me.editMode == me.$ms.constant.FormState.Add) {
          setTimeout(() => {
            me.setRequiredPostDetail(me.invalidDetailPosted);
          }, 100);
        }
      }
    },
    layoutTagDetailOther(newVal, oldVal) {
      const me = this;
      if (newVal !== oldVal) {
        //init layout
        this.initLayoutDetailOther();
        this.completeInitLayoutDetailOther = true;
      }
    },
    'model.ref_no': {
      handler(newValue, oldValue) {
        this.getTitleVoucher();
        if (newValue && newValue !== oldValue) {
          this.titleRefCode = newValue;
        }
      },
      //deep: true,
    },
    'model.posted_date': {
      handler(newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue) {
          if (newValue?.getFullYear() >= 2025 && this.context?.IsCreateTT24) {
            showConfirmValidate(
              `Từ ngày 01/01/2025, Thông tư 107/2017/TT-BTC hướng dẫn chế độ kế toán cho đơn vị HCSN được thay thế bởi Thông tư 24/2024/TT-BTC. Để hạch toán chứng từ phát sinh trong năm ${newValue.getFullYear()}, bạn cần <b>Cập nhật Thông tư 24/2024/TT-BTC<b/>.`,
              'Ngày hạch toán không hợp lệ',
              {Yes: 'Cập nhật ngay', No: 'Hủy'},
              530,
            ).then(answer => {
              if (answer) {
                this.hide();
                EventBusGlobal.$emit(GlobalEventName.showConversionOfAccountingSystemPopup);
              }
            });
          }
        }
      },
      //deep: true,
    },
  },
  mounted() {
    //init layout
    if (this.layoutTagDetail) {
      this.initLayoutDetail();
    }
    //init layout detail other
    setTimeout(() => {
      if (this.layoutTagDetailOther && !this.completeInitLayoutDetailOther) {
        this.initLayoutDetailOther();
      }
    }, 0);

    // Khởi tạo thuộc tính ref_no để tránh lỗi null NHANH3 18.04.2023
    this.model.ref_no = '';

    // Đổi lại combobox Thuế suất đối với những màn hình chứng từ có Thuế
    // tbngoc 06.01.2023
    const me = this;

    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    if (me.propsData && (me.propsData.hasOwnProperty('tax_rate') || me.propsData.hasOwnProperty('vat_rate'))) {
      // HMDUC2: 31/05/2024: Biến đánh dấu PP trực tiếp
      let isDirectTaxMethod =
        store.state[ModuleDbOption]?.dbOptions?.TaxCalculationMethod ===
        me.$ms.constant.TaxCalculationMethod.DirectMethod;
      let taxEnums = this.getTaxEnum(isDirectTaxMethod);
      me.propsData.hasOwnProperty('tax_rate')
        ? (me.propsData.tax_rate.values = Object.values(taxEnums))
        : (me.propsData.vat_rate.values = Object.values(taxEnums));
    }

    // Loại bỏ giá trị nghiệp vụ đảng
    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
    if (
      me.propsData &&
      me.propsData.hasOwnProperty('cash_withdraw_type_name') &&
      me.dbOptions.Particularity !== me.$ms.constant.Particular.DangAudit
    ) {
      let cashWithdrawTypeEnums = _.cloneDeep(me.$ms.constant.CashWithDrawType);
      delete cashWithdrawTypeEnums.ReceiptForInferior;
      delete cashWithdrawTypeEnums.ReceivedReceiptFromSuperiors;
      me.propsData.cash_withdraw_type_name.values = Object.values(cashWithdrawTypeEnums);
    }
    me.DBStartDateString = me.$ms.commonFn.getMomentCustom(me.dbOptions?.DBStartDate).format('DD/MM/YYYY');
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    /**
     * Đối tượng hiển thị grid detail
     */
    gridDetail() {
      return this.$refs[this.refDetail];
    },
    /**
     * Đối tượng hiển thị grid hạch toán đồng thời
     */
    gridDetailParallel() {
      return this.$refs[this.refDetailParallel];
    },
    /**
     * Đối tượng hiển thị grid other detail
     */
    gridDetailOther() {
      return this.$refs[this.refDetailOther];
    },
    /**
     * Index của bản ghi trong list all
     * nvtoan2 21/11/2023
     */
    currentIndexList() {
      const me = this;
      let modules = me.getRealModule();
      const gridData = me.$store.getters[`${modules}/items`],
        config = me.$store.getters[`${modules}/_config`],
        payloadNextBack = me.$store.getters[`${modules}/payloadNextBack`];
      if (Object.keys(config).length && Object.keys(gridData).length) {
        const {field} = config;

        const currentIndex = gridData.findIndex(x => x[field.key] === me.model[field.key]);
        // nếu là bản ghi trong list thì lấy skip ngoài danh sách + index
        if (currentIndex > -1) {
          return (payloadNextBack?.listSkip ?? payloadNextBack?.skip ?? 0) + currentIndex;
        }

        // Nếu không phải bản ghi trong danh sách thì chắc chắn là nó ấn next back => lấy skip
        return payloadNextBack?.skip ?? null;
      }
      return null;
    },
    /**
     * Enable next back voucher
     * NXCHIEN 15.07.2022
     */
    currentIndexBack() {
      const me = this;
      return me.currentIndexList != 0;
    },
    /**
     * Enable next back voucher
     * NXCHIEN 15.07.2022
     */
    currentIndexNext() {
      const me = this;
      let modules = me.getRealModule();
      const listTotal = me.$store.getters[`${modules}/total`];

      return me.currentIndexList != listTotal - 1;
    },

    /**
     * Hiển thị nút Sửa và GHi sổ
     * NXCHIEN 21.03.2023
     */
    isShowEditAndPosted() {
      const me = this;
      //Nếu có ngày hạch toán thì lấy còn không thì lấy ngày chứng từ ghi sổ
      let dateCheck = me.model.posted_date || me.model.ref_date;
      return !me.model.is_posted && me.$ms.commonFn.compareDate(dateCheck, me.dBDateClosed) == 1;
    },
    /**
     * Hiển thị nút Bỏ ghi sổ
     * NXCHIEN 21.03.2023
     */
    isShowUnPosted() {
      const me = this;
      //Nếu có ngày hạch toán thì lấy còn không thì lấy ngày chứng từ ghi sổ
      let dateCheck = me.model.posted_date || me.model.ref_date;
      return me.model.is_posted && me.$ms.commonFn.compareDate(dateCheck, me.dBDateClosed) == 1;
    },
    /**
     * Hiển thị nút Bỏ ghi sổ
     * NXCHIEN 21.03.2023
     */
    isShowRefreshAndApprove() {
      const me = this;
      //Nếu có ngày hạch toán thì lấy còn không thì lấy ngày chứng từ ghi sổ
      let dateCheck = me.model.posted_date || me.model.ref_date;
      return me.$ms.commonFn.compareDate(dateCheck, me.dBDateClosed) == 1;
    },
    /**
     * Hiển thị nút Sửa
     * false sẽ thao tác bình thường
     * pthai 21.03.2023
     */
    isShowEditAndRefresh() {
      const me = this;
      let lastDayofPeriod = null;
      switch (me.model?.pa_month) {
        case 1:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 1, 0)).format('YYYY-MM-DD');
          break;

        case 2:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 2, 0)).format('YYYY-MM-DD');
          break;

        case 3:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 3, 0)).format('YYYY-MM-DD');
          break;

        case 4:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 4, 0)).format('YYYY-MM-DD');
          break;

        case 5:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 5, 0)).format('YYYY-MM-DD');
          break;

        case 6:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 6, 0)).format('YYYY-MM-DD');
          break;

        case 7:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 7, 0)).format('YYYY-MM-DD');
          break;

        case 8:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 8, 0)).format('YYYY-MM-DD');
          break;

        case 9:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 9, 0)).format('YYYY-MM-DD');
          break;

        case 10:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 10, 0)).format('YYYY-MM-DD');
          break;

        case 11:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 11, 0)).format('YYYY-MM-DD');
          break;

        case 12:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 11, 31)).format('YYYY-MM-DD');
          break;

        case 101:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 3, 0)).format('YYYY-MM-DD');
          break;

        case 102:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 6, 0)).format('YYYY-MM-DD');
          break;

        case 103:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 9, 0)).format('YYYY-MM-DD');
          break;

        case 104:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 12, 0)).format('YYYY-MM-DD');
          break;
        case 203:
          lastDayofPeriod = moment(new Date(me.model.pa_year, 12, 0)).format('YYYY-MM-DD');
          break;
        default:
          lastDayofPeriod = null;
          break;
      }
      return me.$ms.commonFn.compareDate(lastDayofPeriod, me.dBDateClosed) === 1;
    },

    /**
     * Danh sách item khi click chuột phải
     * NXCHIEN 08.12.2023
     */
    itemRightClicks() {
      const me = this;
      let res = me.dataRightClick;

      // Danh sách chứng từ ko xem số dư tài khoản
      let notApplys = [
        me.$ms.constant.RefType.BUPlanWithdrawDeposit,
        me.$ms.constant.RefType.BUPlanWithdrawCash,
        me.$ms.constant.RefType.BUPlanWithdrawTransfer,
        me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
        me.$ms.constant.RefType.BUOpeningCommitment,
        me.$ms.constant.RefType.BUCommitmentRequest,
        me.$ms.constant.RefType.BUCommitmentAdjustment,
        me.$ms.constant.RefType.BUExpenseWithdrawAdjustment,
        me.$ms.constant.RefType.BURealExpenseAdjustment,
        me.$ms.constant.RefType.SUTransfer,
        me.$ms.constant.RefType.SUIncrement,
        me.$ms.constant.RefType.SUDecrement,
        me.$ms.constant.RefType.GLPayrollExpense,
        me.$ms.constant.RefType.PAPersonalIncomeTax,
        me.$ms.constant.RefType.SASaleInvoice,
        me.$ms.constant.RefType.PAPersonalIncomeTax,
        // me.$ms.constant.RefType.PAPersonalIncomeTax,
      ];

      // TODO: xử lý thêm phần nhập số dư ban đầu
      if (me.model.ref_type && notApplys.find(x => x == me.model.ref_type)) {
        res = me.dataRightClick.filter(x => x.action != me.$ms.constant.Command.ViewAccount);
      }

      // nếu mode xem thì chỉ giữ lại Xem số dư tài khoản
      if (me.editMode == me.$ms.constant.FormState.View) {
        res = res.filter(x => x.action == me.$ms.constant.Command.ViewAccount);
      }

      return res;
    },
    /**
     * Computed trạng thái nút duyệt khi chứng từ được mở từ chứng từ khác
     * NBTIN 08.01.2024
     */
    stateApprove() {
      if (this._formParam?.isOtherVoucherShow) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      loadApplyLayout: ModuleLayout + '/loadApply',
    }),
    /**
     * Xử lý cấu hình load layout cho grid detail
     */
    initLayoutDetail() {
      const me = this;
      if (me.layoutTagDetail) {
        let layout = me.getCacheLayoutTemplate(me.layoutTagDetail);

        if (!layout || process.env.NODE_ENV === 'development') {
          me.loadApplyLayout(me.layoutTagDetail).then(layout => {
            //set cache
            me.setCacheLayoutTemplate(me.layoutTagDetail, layout);

            me.applyLayout(me.layoutTagDetail, me.gridDetail, layout, true);
          });
        } else {
          me.applyLayout(me.layoutTagDetail, me.gridDetail, layout, true);
        }
      }
    },

    /**
     * Xử lý cấu hình load layout cho grid detail other
     */
    initLayoutDetailOther() {
      const me = this;
      if (me.layoutTagDetailOther) {
        let layout = me.getCacheLayoutTemplate(me.layoutTagDetailOther);

        if (!layout || process.env.NODE_ENV === 'development') {
          me.loadApplyLayout(me.layoutTagDetailOther).then(layout => {
            //set cache
            me.setCacheLayoutTemplate(me.layoutTagDetailOther, layout);

            me.applyLayout(me.layoutTagDetailOther, me.gridDetailOther, layout);
          });
        } else {
          me.applyLayout(me.layoutTagDetailOther, me.gridDetailOther, layout);
        }
      }
    },

    /**
     * lấy mẫu layout từ cache
     */
    getCacheLayoutTemplate(tag) {
      const me = this;
      try {
        let layoutTemplate;
        let cacheKey = me.getCacheLayoutTemplateKey(tag);
        if (cacheKey) {
          // let cacheData = await me.$ms.indexedDB.get(cacheKey);
          let cacheData = me.$ms.commonFn.getSessionStorage(cacheKey);
          if (cacheData) {
            layoutTemplate = JSON.parse(cacheData);
          }
        }
        return layoutTemplate;
      } catch (ex) {
        console.error(ex);
      }
      return null;
    },
    /**
     * lưu cache mẫu layout
     */
    setCacheLayoutTemplate(tag, layout) {
      const me = this;
      let cacheKey = me.getCacheLayoutTemplateKey(tag);
      if (cacheKey) {
        // let cacheData = await me.$ms.indexedDB.get(cacheKey);
        me.$ms.commonFn.setSessionStorage(cacheKey, JSON.stringify(layout));
      }
    },
    /**
     * lấy cache key mẫu layout
     */
    getCacheLayoutTemplateKey(tag) {
      const me = this;
      let cacheKey = '';
      if (me.Context && me.Context.UserID && tag) {
        cacheKey = 'LayoutTemplate_{0}_{1}_{2}'.format(tag, me.Context.UserID, me.Context.DatabaseId);
      }
      return cacheKey;
    },

    /**
     * callback chỉnh layout
     * NCPHUOC 08/07/2022
     */
    callbackSettingLayout(layouts) {
      if (Array.isArray(layouts)) {
        layouts.forEach(item => {
          this.setCacheLayoutTemplate(item.tag, item);
        });
        this.initLayoutDetail();
        this.initLayoutDetailOther();
      }
    },

    // hàm xử lý thêm cho các cột trên tùy chỉnh
    customSettingLayout(config, tag = null) {},

    // Hàm xử lý thêm cho các cột khi lấy lại mặc định
    customSettingLayoutDefault(config, tag = null) {},

    // Hàm xử lý thêm cho các cột khi lưu template layout
    updateSettingLayout(config) {},

    // HMDUc2: Thêm hàm get Enum cột thuế suất
    getTaxEnum(isDirectTaxMethod) {
      return this.$ms.constant.TaxRateInventory;
    },

    /**
     * Mở form cấu hình layout
     * NCPHUOC 08/07/2022
     */
    clickSettingLayout() {
      // 24.04.2023 NNLINH thêm quyền ẩn hiện cột.
      this.checkActionPermissionAlert(this.$ms.constant.Permission.SettingLayout);
      popupUtil.show(
        'SettingLayout',
        Object.assign(this.getConfigLayout(), {
          options: {
            submit: this.callbackSettingLayout.bind(this),
            customSettingLayout: this.customSettingLayout.bind(this),
            customSettingLayoutDefault: this.customSettingLayoutDefault.bind(this),
            updateSettingLayout: this.updateSettingLayout.bind(this),
          },
        }),
      );
    },

    /**
     * Click phím tắt
     * NXCHIEN 30.12.2022
     */
    clickShortkeyBtn() {
      popupUtil.show('ShortkeyDetailPopup');
    },

    /**
     * override hàm này để cấu hình truyền layout
     * NCPHUOC 08/07/2022
     */
    getConfigLayout() {
      return [];
    },
    /**
     * Render mẫu
     * Modified TVDAT thêm tham số xác định apply layout của gridDetail hay gridDetailOther
     */
    applyLayout(tag, grid, layout, isGridDetail) {
      const me = this;
      if (isGridDetail) {
        me.layout = me.convertToLayoutTemplete(layout);
      } else {
        me.layoutOther = me.convertToLayoutTemplete(layout);
      }
      let columns = me.getLayoutColumn(layout, tag);

      //Lấy dbOption từ store để luôn lấy được giá trị mới nhất
      me.$store
        .dispatch('dbOption/getDbOptions')
        .then(dbOptions => {
          // custom column theo dbOption
          if (dbOptions) {
            me.applyColumnByDbOption(columns, dbOptions);
          }
        })
        .finally(() => {
          // custom lại column trước khi load
          me.customColumns(columns);
          //Lưu lại column cuối cùng trước khi render lên grid
          me.originColumns = columns;

          grid.initColumns(columns);
        });
    },

    /**
     * Hàm custom hiển thị layout theo dbOption
     * nthien4 13.07.2022
     */
    applyColumnByDbOption(columns, dbOptions) {
      let me = this;
      columns.forEach(item => {
        switch (item.dataField) {
          // mã dự phòng
          case 'budget_provide_code':
            if (!dbOptions.IsDetailbyBudgetProvidence) {
              item.visible = false;
            }
            break;
          // ctmt, dự án
          case 'project_code':
            if (!dbOptions.UseProjectManagement) {
              item.visible = false;
            }
            break;
          // tiết tiểu mục
          case 'budget_detail_item_code':
            if (!dbOptions.AccountingBudgetDetailItemCode) {
              item.visible = false;
            }
            break;
          // Danh mục dự án: hoạt động, khoản chi
          case 'project_activity_id':
          case 'project_expense_id':
          case 'project_expense_code':
            if (!dbOptions.IsProjectDetailbyActivityAndExpense || !dbOptions.UseProjectManagement) {
              item.visible = false;
            }
            break;
          // đề tài
          case 'topic_code':
            if (!dbOptions.UseTopicManagement) {
              item.visible = false;
            }
            break;
          // hợp đồng
          case 'contract_no':
            if (!dbOptions.UseContract) {
              item.visible = false;
            }
            break;
          // Nhiệm vụ
          case 'task_code':
            if (!dbOptions.UseTask) {
              item.visible = false;
            }
            break;
          // Nguồn năm trước
          case 'is_source_before_year':
            if (!dbOptions.UseSourceBeforeYear) {
              item.visible = false;
            }
            break;
          // Cơ cấu vốn
          case 'fund_structure_name':
            if (!dbOptions.UseInvestorAccounting) {
              item.visible = false;
            }
            break;
          default:
            me.applyColumnByDbOptionCustom(item, dbOptions);
            break;
        }
      });
    },

    /**
     * Custom các cột có dataField khác theo dbOptions
     */
    applyColumnByDbOptionCustom(column, dbOptions) {},

    convertToLayoutTemplete(layout) {
      let layoutTemplete = {};
      if (layout) {
        layoutTemplete.code = layout.tag;
        layoutTemplete.is_system = layout.is_system;
        layoutTemplete.config = layout.config;
        layoutTemplete.layout_template_id = layout.layout_template_id;
        layoutTemplete.layout_template_name = layout.layout_template_name;
        layoutTemplete.tag = layout.tag;
        layoutTemplete.user_id = layout.user_id;
        layoutTemplete.is_edited_by_fund = layout.is_edited_by_fund;
      }
      return Object.assign({}, layoutTemplete);
    },

    /**
     * Lấy thông tin column render từ thông tin của mẫu
     */
    getLayoutColumn(layout, tag) {
      if (layout != undefined) {
        const me = this;
        let columns = JSON.parse(layout.config);

        //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
        if (layout.is_system) {
          me.localizationColumn(columns, tag);
        }
        //nnlam: orderby lại theo sort_order và lock.
        columns = _(columns)
          .chain()
          .sortBy('sort_order')
          .sortBy(function (column) {
            return !column.lock;
          })
          .value();
        return columns;
      }
    },
    /**
     * Xử lý ngôn ngữ cho caption và title của column
     */
    localizationColumn(columns, tag) {
      const me = this,
        culture = me.Culture;

      //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
      if (culture !== 'vi') {
        let fn = function (column, field, key) {
          let text = me.$ms.commonFn.getColumnText(field, tag);
          if (typeof text !== 'undefined') {
            column[field] = text;
          }
        };

        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          fn(col, 'caption', col.dataField);
          fn(col, 'title', col.dataField + 'Title');
        }
      }
    },
    /**
     * @override: Thêm _gridDetails để cache lại cấu hình grid
     * @param {*} e
     * @param {*} close
     * NCPHUOC 29/03/2022
     */
    beforeOpen(e, close) {
      const me = this;
      me.super('beforeOpen', baseDetailPopup, e, close);

      me.isFromCompareConvert = me._formParam?.isFromCompareConvert;

      if (!me._gridDetails) {
        me._gridDetails = {};
      }
    },

    /**
     * Thực hiện next voucher
     * NXCHIEN 10.05.2022
     * NCPHUOC 25/07/2022: Tối ưu show popup
     */
    async nextVoucher() {
      const me = this;
      const dataRow = await me.getNextVoucher(me.module);

      if (dataRow) {
        me.showVoucher(dataRow);
      }
    },

    /**
     * Lấy chứng từ tiếp theo
     * nvtoan2 22/11/2023
     */
    async getNextVoucher() {
      const me = this;
      let modules = me.getRealModule();
      const gridData = me.$store.getters[`${modules}/items`],
        config = me.$store.getters[`${modules}/_config`];
      let payloadNextBack = me.$store.getters[`${modules}/payloadNextBack`];

      if (Object.keys(config).length && Object.keys(gridData).length) {
        const {field} = config;

        const currentIndex = gridData.findIndex(x => x[field.key] === me.model[field.key]);
        const nextIndex = currentIndex + 1;

        // Lúc chưa call next back thì lưu lại 1 số thông tin skip
        if (currentIndex > -1) {
          payloadNextBack.listSkip = payloadNextBack.listSkip ?? payloadNextBack.skip ?? 0;
          payloadNextBack.skip = payloadNextBack.listSkip + currentIndex;
        }

        payloadNextBack.skip++;
        if (currentIndex == gridData.length - 1 || currentIndex == -1) {
          payloadNextBack.take = 1;
          payloadNextBack.isNextBack = true;

          let nextData = await me.$store.dispatch(`${modules}/load`, payloadNextBack);
          if (nextData && nextData.PageData?.length > 0) {
            me.$store.dispatch(`${modules}/updatePayloadNextBack`, payloadNextBack);

            return nextData.PageData[0];
          }
        } else {
          return gridData[nextIndex];
        }
      }

      return null;
    },

    /**
     * Thực hiện back voucher
     * NXCHIEN 10.05.2022
     */
    async backVoucher() {
      const me = this;
      const dataRow = await me.getPreviousVoucher(me.module);

      if (dataRow) {
        me.showVoucher(dataRow);
      }
    },

    /**
     * Lấy chứng từ đứng trước
     * nvtoan2 22/11/2023
     */
    async getPreviousVoucher() {
      const me = this;
      let modules = me.getRealModule();
      const gridData = me.$store.getters[`${modules}/items`],
        config = me.$store.getters[`${modules}/_config`];
      let payloadNextBack = me.$store.getters[`${modules}/payloadNextBack`];

      if (Object.keys(config).length && Object.keys(gridData).length) {
        const {field} = config;

        const currentIndex = gridData.findIndex(x => x[field.key] === me.model[field.key]);
        const preIndex = currentIndex - 1;

        // Lúc chưa call next back thì lưu lại thông tin skip từ ngoài danh sách, skip hiện tại
        if (currentIndex > -1) {
          payloadNextBack.listSkip = payloadNextBack.listSkip ?? payloadNextBack.skip ?? 0;
          payloadNextBack.skip = payloadNextBack.listSkip + currentIndex;
        }

        payloadNextBack.skip--;
        if (currentIndex == 0 || currentIndex == -1) {
          payloadNextBack.take = 1;
          payloadNextBack.isNextBack = true;

          let preData = await me.$store.dispatch(`${modules}/load`, payloadNextBack);
          if (preData && preData.PageData?.length > 0) {
            me.$store.dispatch(`${modules}/updatePayloadNextBack`, payloadNextBack);

            return preData.PageData[0];
          }
        } else {
          return gridData[preIndex];
        }
      }

      return null;
    },

    /**
     * Lấy ra module thật
     * k override lại thì lấy module mặc định
     * nvtoan2 23/11/2023
     */
    getRealModule() {
      return this.module;
    },

    /**
     * Lock command thực hiện để tránh dup xử lý
     * nqhuy1 26/3/2024
     */
    lockCommand(lockFromBase = false) {
      const me = this;
      // trường hợp đã lock ở màn detail rồi gọi xuống hàm base thì return
      if (me._commandLock?.lockFromBase === false && lockFromBase) return;
      if (me._commandLock) {
        throw 'Locking ';
      }
      me._commandLock = {
        lockFromBase: lockFromBase,
      };
      // mở khóa lock
      me.$nextTick(() => {
        setTimeout(() => {
          delete me._commandLock;
        }, window._lockCommandTimeout || 500);
      });
    },

    /**
     * Xử lý submit grid trước khi xử lý click action
     * NCPHUOC 05/04/2022
     * @param {*} command
     */
    async commandClick(command) {
      const me = this;
      me.lockCommand(true);
      switch (command) {
        case this.$ms.constant.Command.Postpone:
          this.postponeVoucher();
          break;
        case this.$ms.constant.Command.NextVoucher:
          this.nextVoucher();
          break;
        case this.$ms.constant.Command.BackVoucher:
          this.backVoucher();
          break;
        case this.$ms.constant.Command.SaveView:
        case this.$ms.constant.Command.Posted:
          me.checkRefTypeVoucherCallMonitor(me.refType);
          this.super('commandClick', baseDetailPopup, command);
          return;
        default:
          this.super('commandClick', baseDetailPopup, command);
          return;
      }
      this.pushTrans(command);
    },

    /**
     * Sửa nhanh chứng từ
     * lhphong 29.05.2023
     * @param {*} result
     */
    async quickEditVoucher(result) {
      const me = this;
      // check có quyền ghi sổ hay không - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Posted);
      //Khởi tạo param
      let param = {
        ignoreAll: false,
        ignores: ['string'],
        data: {
          refType: result.ref_type,
          refId: result.ref_id,
        },
      };

      me.loading = true;
      //Gọi api ghi sổ
      await me.$store
        .dispatch(`${me.module}/quickEditVoucher`, param)
        .then(res => {
          me.loading = false;
          if (res.is_success === true) {
            // me.postedSuccess(res, isShowInfo, param, isSaveSuccess);
            me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));

            //
            me.isQuickEditVoucher = false;
            // call lại submit khi ghi sổ để dữ liệu bảng kê được chính xác
            if (me.options && typeof me.options.submit === 'function') {
              me.options.submit();
            }

            // Lưu và đóng form
            if (me.saveAndClose) {
              me.hide();
            }
          }
        })
        .catch(ex => {
          //Show cảnh báo ghi sổ
          me.loading = false;
          //Không phải lỗi nghiệp vụ
          me.$toast.error('Đã xảy ra lỗi xảy ra!');
          console.error(ex);
        })
        .finally(() => {
          me.finallyOnPostedCustom();
        });
    },

    /**
     * Hoãn
     * @author nnnam - 26/9/2022
     * Modified by NBTIN 09.02.2023: Sửa lỗi hoãn khi sinh chứng từ phải quay về chứng từ gốc - BUG 298209
     */
    async postponeVoucher() {
      const me = this;
      let mode = this.editMode;

      me.isQuickEditVoucher = false;

      await me.submitGridEditor(mode);
      me.resetValidateGrid();

      if (mode == this.$ms.constant.FormState.Add || mode == this.$ms.constant.FormState.Duplicate) {
        if (me.currencyCode) {
          if (me.model.currency_code !== me.oldDataItem.currency_code) {
            me.currencyCode = me.oldDataItem.currency_code;
          }
        }

        let isDefferent = Object.keys(me.oldDataItem).some(
          key =>
            !_.isEqualWith(me.model[key], me.oldDataItem[key], (valX, valY, field) => {
              if (field == '__vKeyValue') {
                return true;
              }
            }),
        );

        if (isDefferent) {
          if (me._formParam?.data?.IsGenerateData) {
            me._formParam.data.IsGenerateData = false;
            me.activeVoucher();
          } else {
            this.resetData();
          }
        } else {
          me.activeVoucher();
        }
      } else {
        this.editMode = this.$ms.constant.FormState.View;
        if (me.currencyCode) {
          if (me.model.currency_code !== me.oldDataItem.currency_code) {
            me.currencyCode = me.oldDataItem.currency_code;
          }
        }

        /** NXCHIEN 10.07.2022 Nếu là sinh chứng từ thì cần refresh lại */
        if (me._formParam?.data?.IsGenerateData) {
          me._formParam.data.IsGenerateData = false;
          me.refresh();
        } else {
          this.resetData();
        }
      }
    },

    /**
     * Active voucher trước đó khi bấm hoãn
     * @author nnnam - 13/9/2022
     */
    activeVoucher() {
      const me = this;
      me.prev_data
        ? me.showVoucher(me.prev_data, {
            currentPath: me.backRouter,
          })
        : me.hide();
    },

    /**
     * Show chứng từ khi có dữ liệu
     * @author nnnam - 13/9/2022
     */
    showVoucher(row, options = {}) {
      let me = this,
        config = me.$store.getters[`${me.module}/_config`];

      let newRef = row?.ref_type;
      const {field} = config;

      if (newRef == me.model?.ref_type) {
        me.editMode = me.$ms.constant.FormState.View;
        Object.assign(me._formParam, {id: row[field.key]}, options);
        me.view(Object.assign({id: row[field.key]}, options));
      } else {
        let types = me.$ms.constant.RefTypeMapperDetailName;

        let name = Object.keys(types).find(
          item => (Array.isArray(types[item]) && types[item].some(x => x == newRef)) || types[item] == newRef,
        );

        name &&
          popupUtil
            .show(
              name,
              Object.assign(
                {
                  mode: me.$ms.constant.FormState.View,
                  id: row[field.key],
                  data: row,
                  currentPath: me._currentPath,
                  formApproveName: me._formParam?.formApproveName,
                  isBackRouter: me._formParam.isBackRouter,
                },
                options,
              ),
            )
            .then(x => {
              setTimeout(() => {
                me.hide(true);
              }, 0);
            });
      }
    },

    /**
     * Thêm chứng từ bằng Reftype
     * @author nnnam - 19/9/2022
     */
    async addVoucher(reftype, name, option) {
      // check quyền Thêm
      this.checkActionPermissionAlert(this.$ms.constant.Permission.Add);

      let me = this;
      delete me._formParam?.data?.IsGenerateData;

      if (reftype && me.model.ref_type != reftype) {
        await popupUtil.show(
          name,
          Object.assign({
            mode: me.$ms.constant.FormState.Add,
            // backRouter: me.backRouter,
            isBackRouter: me._formParam.isBackRouter,
            currentPath: me._currentPath,
            // currentTitle: me._currentTitle
          }),
        );
        setTimeout(() => me.hide(true), 0);
      } else {
        me.add({
          mode: me.$ms.constant.FormState.Add,
          currentPath: location.pathname,
        });
      }
    },

    /**
     * Validate trước khi save
     * NXCHIEN 27.06.2022
     * NVTUAN1 01.08.2022: Sửa lại rule validate sinh hạch toán đồng thời khi cất và tối ưu code
     * NVTUAN1 17.08.2022: Bổ sung thêm validate nghiệp vụ đặc thù của chứng từ
     */
    async validateBeforeSave(mode) {
      const me = this;

      // validate control
      if (!me.validateComponents(mode)) {
        return;
      }
      // Validate nghiệp vụ //Type: 1: Định khoản ko hợp lệ | 2: Chưa nhập dòng chi tiết
      let mes = me.validateBusinessBeforeSave();
      if (mes && Object.keys(mes).length > 0) {
        if (mes.showUpdateTT24) {
          showConfirmValidate(mes.content, mes.title, {Yes: 'Cập nhật ngay', No: 'Hủy'}, 530).then(answer => {
            if (answer) {
              this.hide();
              EventBusGlobal.$emit(GlobalEventName.showConversionOfAccountingSystemPopup);
            }
          });
        } else {
          showError(mes.content, mes.title);
        }
        return;
      }

      // Thêm loading để ngăn gửi request nhiều lần (NHANH3 26.10.2023)
      me.loading = true;

      // Validate danh mục còn tồn tại không NHANH3 21.04.2023
      let mesError = await me.validateExistsDictionary();
      if (mesError) {
        me.loading = false;
        showError(mesError, me.$tm('i18nEnum.ValidateCode.ExistDictionary')).then(() => {
          me.setFocusAfterValidate();
        });
        return;
      }

      //Validate nghiệp vụ đặc thù của chứng từ
      let isValidateBusinessCustom = await me.validateBusinessBeforeSaveCustom(mode);
      if (!isValidateBusinessCustom) {
        me.loading = false;
        return;
      }

      //Nếu có Hạch toán đồng thời thì mới thực hiện validate sinh hạch toán đồng thời khi cất
      //gridDetail => cấu hình đúng là grid của hạch toán
      //gridDetailParallel => Cấu hình đúng là grid của hạch toán đồng thời
      if (this.gridDetail && this.gridDetailParallel) {
        //Validate sinh hạch toán đồng thời và thực hiện cất luôn
        me.validateGenerateParallel(mode);
        return;
      } else {
        // Check các trường thông tin bắt buộc nhập theo tài khoản NHANH3 28.05.2023
        let message = await me.validatePosted();
        if (message && message.content && message.type == 1) {
          me.loading = false;
          showError(message.content, me.$tm('i18nBaseForm.Message.FailSave')).then(() => {
            me.setErrorPost(me.invalidPost);
          });
          return;
        }
      }

      //Gọi lên hàm save của cha để thực hiện cất
      me.super('save', baseDetailPopup, mode);
    },

    /**
     * Hàm reset thông tin lỗi
     * NHANH3 26.05.2023
     */
    resetInfoError() {
      this.firstElementError = null;
      this.infoElementError = {};
      this.isMasterError = false;
    },

    /**
     * Hàm validate danh mục có tồn tại không
     * NHANH3 21.04.2023
     */
    async validateExistsDictionary() {
      const me = this;

      // Tạo biến lưu danh sách lỗi và reset thông tin lỗi trước đó để validate lại
      var listError = new Set();

      me.resetInfoError();

      me.resetValidateGrid();

      // Lấy ra những dữ liệu cần validate gọi về server để check
      await me.checkDataExistServer();

      // Check master
      await me.validateExistsDictionaryMaster(listError);

      // Check detail
      await me.validateExistsDictionaryDetail(listError);

      // Cộng các lỗi thành 1 chuỗi
      if (listError && listError.size > 0) {
        return me.$tm('i18nBaseForm.Validate.ExistDictionary').format(Array.from(listError).join('; '));
      }

      return null;
    },

    /**
     * Hàm lấy danh sách các combox trên thông tin master
     * NHANH3 15.05.2023
     * MODIFIED BY NBTIN 11.10.2023: Sửa lỗi chỉ lấy các combobox ở phần master, không lấy ở phần header filter (trường hợp ở các bảng kê đang lấy header filter của grid chi tiết)
     */
    getAllComboboxMaster() {
      var comboboxs = [];
      const $el = this.$el;
      const $controls = $el.querySelectorAll('.ms-combobox.ms-validate:not(.ms-input-filter-value)');
      if ($controls && $controls.length > 0) {
        $controls.forEach(item => {
          if (typeof item.getVueInstance === 'function') {
            comboboxs.push(item.getVueInstance());
          }
        });
      }

      return comboboxs;
    },

    /**
     * Hàm lấy dữ liệu cần validate trên form gửi về server để check xem có tồn tại không
     * NHANH3 10.05.2023
     */
    async checkDataExistServer() {
      const me = this;
      // Biến lưu các data cần đưa về server để check
      var dataNeedChecks = {};

      // Lấy ra các combobox trên giao diện master để check
      var comboboxs = me.getAllComboboxMaster();

      // Duyệt từng combobox trên thông tin master
      for (let combobox of comboboxs) {
        var config = _.cloneDeep(me.$ms.constant.StoreConfig[combobox.valueField]);
        if (!config || config.queryMode != 'remote' || !combobox.modelValue || !combobox.checkExits) {
          continue;
        }

        // Hàm custom lại config để các màn đặc biệt override lại
        config = me.customStoreConfig(config);

        // Trường hợp combobox multiple
        if (combobox.isMultiple) {
          var values = combobox.modelValue.split(';');
          if (dataNeedChecks[config.checkField]) {
            values.forEach(value => {
              if (dataNeedChecks[config.checkField].indexOf(value) == -1) {
                dataNeedChecks[config.checkField].push(value);
              }
            });
          } else {
            dataNeedChecks[config.checkField] = values;
          }
        }
        // Trường hợp combobox thường
        else {
          if (dataNeedChecks[config.checkField]) {
            if (dataNeedChecks[config.checkField].indexOf(combobox.modelValue) == -1) {
              dataNeedChecks[config.checkField].push(combobox.modelValue);
            }
          } else {
            dataNeedChecks[config.checkField] = [combobox.modelValue];
          }
        }
      }

      // Check detail
      for (const key in me._gridDetails) {
        // Lấy ra từng grid detail trên màn hình
        const element = me._gridDetails[key];

        if (!me.$refs[element] || !me.$refs[element].datax) {
          continue;
        }

        // Lấy ra danh sách dữ liệu trên grid có state khác rỗng và xóa
        var listData = [];
        listData = me.getDataValidateDictionary(element);

        // Lấy danh sách các cột trong grid
        let listColumn = me.$refs[element].columnFull;

        // Duyệt từng cột của mỗi dòng data
        for (let column of listColumn) {
          for (let item of listData) {
            var config = _.cloneDeep(me.$ms.constant.StoreConfig[column.dataField]);
            if (!config || config.queryMode != 'remote') {
              continue;
            }

            // Hàm custom lại config để các màn đặc biệt override lại
            config = me.customStoreConfig(config);

            var value = item[`${config.valueField}`];
            if (!value) {
              continue;
            }

            if (dataNeedChecks[config.checkField]) {
              if (dataNeedChecks[config.checkField].indexOf(value) == -1) {
                dataNeedChecks[config.checkField].push(value);
              }
            } else {
              dataNeedChecks[config.checkField] = [value];
            }
          }
        }
      }

      // Gọi api lên server để check
      me.resultCheckExist = await accountingObjectAPI.checkExist(dataNeedChecks);
    },

    /**
     * Tách hàm để override
     * NXCHIEN 23.06.2023
     */
    getDataValidateDictionary(element) {
      const me = this;
      return me.$refs[element].datax.filter(
        item => item.state != me.$ms.constant.ModelState.Empty && item.state != me.$ms.constant.ModelState.Delete,
      );
    },

    /**
     * Mỗi màn có thông tin master khác nhau nên sinh ra hàm này để override
     * NHANH3 24.04.2023
     */
    async validateExistsDictionaryMaster(listError) {
      // Lấy ra các combobox trên giao diện để check
      var comboboxs = this.getAllComboboxMaster();

      // Duyệt từng combobox
      for (let combobox of comboboxs) {
        if (combobox.modelValue && combobox.valueField) {
          var config = _.cloneDeep(this.$ms.constant.StoreConfig[combobox.valueField]);
          if (!config || !combobox.modelValue || !combobox.checkExits) {
            continue;
          }

          // Hàm custom lại config để các màn đặc biệt override lại
          config = this.customStoreConfig(config);

          // Trường hợp combobox multiple
          if (combobox.isMultiple) {
            var values = combobox.modelValue.split(';');

            for (let value of values) {
              // Kiểm tra xem giá trị còn tồn tại trong danh mục không (true: có; false, null: không; undefined: không trong trường hợp kiểm tra)
              var data = await this.checkExistDictionary(config.checkField, value, config.queryMode, config.storeName);

              if (!data && data != undefined) {
                // Gắn tên biến lỗi và display vào map để tránh bị trùng
                listError.add(config.caption);
                // Set message error cho combobox
                combobox.errorMessage = `${config.caption} không tồn tại`;
                this.isMasterError = true;
                break;
              } else {
                combobox.errorMessage = ``;
              }
            }
          }
          // Trường hợp combobox thường
          else {
            // Kiểm tra xem giá trị còn tồn tại trong danh mục không (true: có; false, null: không; undefined: không trong trường hợp kiểm tra)
            var data = await this.checkExistDictionary(
              config.checkField,
              combobox.modelValue,
              config.queryMode,
              config.storeName,
            );

            if (!data && data != undefined) {
              // Gắn tên biến lỗi và display vào map để tránh bị trùng
              listError.add(config.caption);
              // Set message error cho combobox
              combobox.errorMessage = `${config.caption} không tồn tại`;
              this.isMasterError = true;
            } else {
              combobox.errorMessage = ``;
            }
          }
        }
      }
    },

    /**
     * Hàm validate detail có tồn tại trong danh mục không
     * NHANH3 24.04.2023
     */
    async validateExistsDictionaryDetail(listError) {
      const me = this;

      let itemErrors = [];
      // Check detail
      for (const key in me._gridDetails) {
        // Lấy ra từng grid detail trên màn hình
        const element = me._gridDetails[key];

        if (!me.$refs[element] || !me.$refs[element].datax) {
          continue;
        }

        // Lấy ra danh sách dữ liệu trên grid có state khác rỗng
        var listData = [];
        listData = me.getDataValidateDictionary(element);

        // Lấy danh sách các cột trong grid
        let listColumn = me.$refs[element].columnFull;
        let idField = this.$refs[element].idField;

        // Duyệt từng cột của mỗi dòng data
        for (let column of listColumn) {
          for (let item of listData) {
            var config = _.cloneDeep(me.$ms.constant.StoreConfig[column.dataField]);
            if (!config) {
              continue;
            }

            // Hàm custom lại config để các màn đặc biệt override lại
            config = me.customStoreConfig(config);

            var value = item[`${config.valueField}`];
            if (!value) {
              continue;
            }

            var data = await me.checkExistDictionary(config.checkField, value, config.queryMode, config.storeName);

            if (!data && data != undefined) {
              var caption = me.customCaptionError(column.dataField, config.caption);

              // Gán tên trường và display vào biến chung
              listError.add(caption);

              itemErrors.push({
                column: column,
                item: item,
                caption: caption,
              });

              // Nếu cột được hiển thị trên giao diện
              if (column.visible) {
                // Lấy ra row bằng refs theo detail_id
                var row = this.$refs[element].$refs[`trEditor_${item[idField]}`];
                if (!row || row.length == 0) {
                  continue;
                }

                // Gán thông tin lỗi cho cell
                row[0].$refs[`cellEditor_${column.dataField}`][0].displayError = true;
                row[0].$refs[`cellEditor_${column.dataField}`][0].errorMessage = `${caption} không tồn tại`;

                // Set element lỗi đầu tiên
                if (!this.firstElementError) {
                  this.firstElementError = row[0].$refs[`cellEditor_${column.dataField}`][0];
                }

                // Lấy ra thông tin vị trí của element lỗi đầu tiên trên grid
                if (
                  !this.infoElementError.colIndex &&
                  !this.infoElementError.rowIndex &&
                  !this.infoElementError.col &&
                  !this.infoElementError.gridName
                ) {
                  this.infoElementError = {
                    colIndex: row[0].$refs[`cellEditor_${column.dataField}`][0].colIndex,
                    rowIndex: row[0].$refs[`cellEditor_${column.dataField}`][0].rowIndex,
                    col: column,
                    gridName: element,
                  };
                }
              }
            }
          }
        }
      }

      me.processValidateData(itemErrors);
    },

    /**
     * Xử lý sau khi validate Danh mục
     * NXCHIEN 23.06.2023
     */
    processValidateData(itemErrors) {},

    /**
     * Hàm custom lại store config khi check danh mục tồn tại
     * NHANH3 19.06.2023
     */
    customStoreConfig(config) {
      return config;
    },

    /**
     * Hàm custom tên lỗi
     */
    customCaptionError(dataField, caption) {
      return caption;
    },

    /**
     * Hàm check danh mục có tồn tại không theo tên biến và giá trị truyền vào
     * NHANH3 08.05.2023
     */
    async checkExistDictionary(checkField, value, queryMode, storeName) {
      if (!checkField || value == null || value == undefined || value == '00000000-0000-0000-0000-000000000000') {
        return;
      }

      // Biến lưu danh sách dữ liệu lấy từ cache hoặc gọi API
      let recentData = [];
      // Biến lưu giữ liệu tìm thấy
      let data = null;

      // Nếu được lưu vào cache
      if (queryMode == 'local') {
        if (!storeName) return;

        recentData = this.$store.state[storeName].items;
      }
      // Nếu là trường hợp được gọi server kiểm tra
      else if (queryMode == 'remote') {
        recentData = this.resultCheckExist[checkField];
      }

      if (recentData == undefined || recentData == null) {
        return;
      }

      data = recentData.find(x => x[checkField] == value) || false;
      return data;
    },

    /**
     * Hàm validate nghiệp vụ đặc thù của chứng từ. DEV override lại hàm này để validate
     * NVTUAN1 17.08.2022
     */
    async validateBusinessBeforeSaveCustom(mode) {
      let isValid = true;
      return isValid;
    },

    /**
     * @override
     * Commit grid editing before save
     */
    async save(mode) {
      const me = this;

      await me.submitGridEditor(mode);

      me.validateBeforeSave(mode);
    },

    /**
     * @override
     * Add thêm reftype vào model các dòng chi tiết và dòng master trước khi submit
     * NCPHUOC 20/07/2022
     * Note: màn hình nào có 2 reftype thì override lại
     * modified by ntchuyen 20.10.2023 Nhân bản thì clone tham số in từ chứng từ gốc
     */
    customSubmitParam(saveParam) {
      const me = this;
      if (saveParam.Model && me.refType) {
        saveParam.Model.ref_type = me.refType;
        const {_gridDetails} = me;
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              if (Array.isArray(saveParam.Model[key])) {
                saveParam.Model[key].forEach(x => {
                  if (x.state === me.$ms.constant.ModelState.Insert || x.state === me.$ms.constant.ModelState.Update) {
                    x.ref_type = me.refType;
                  }
                });
              }
            }
          }
        }
      }
      // Nếu nhân bản hoặc thêm mới từ chứng từ hiện thời thì bổ sung tham số đánh dấu để clone tham số in từ chứng từ gốc
      if (me.refType && me._formParam && me._formParam.id && me.editMode == me.$ms.constant.FormState.Duplicate) {
        switch (me.refType) {
          case MSConstant.RefType.BUPlanWithdrawTransfer:
          case MSConstant.RefType.BUTransfer:
          case MSConstant.RefType.BUPlanWithdrawCash:
          case MSConstant.RefType.BUPlanWithdrawDeposit:
          case MSConstant.RefType.BUPlanWithdrawSalaryTransfer:
          case MSConstant.RefType.BUTreasuryFundTransferSalary:
          case MSConstant.RefType.BUTreasuryFundTransferInsurancePayment:
          case MSConstant.RefType.CAReceiptPlanWithdraw:
          case MSConstant.RefType.BUTransferPurchase:
          case MSConstant.RefType.BUTransferFixedAsset:
          case MSConstant.RefType.BUTransferSalary:
          case MSConstant.RefType.BUTransferDeposit:
          case MSConstant.RefType.BADeposit:
          case MSConstant.RefType.CAReceipt:
          case MSConstant.RefType.BAWithDraw:
          case MSConstant.RefType.BATransferWithdraw:
          case MSConstant.RefType.BAWithdrawPurchase:
          case MSConstant.RefType.BAWithDrawFixedAsset:
          case MSConstant.RefType.BAWithdrawVendor:
          case MSConstant.RefType.BAWithDrawSalary:
          case MSConstant.RefType.BABankTransfer:
          case MSConstant.RefType.CAPaymentDeposit:
            saveParam.PreviouslyOrgiginalId = me._formParam.id; // id chứng từ gốc nhân bản
            break;
          default:
            break;
        }
      }
    },

    /**
     * Submit các grid đang edit
     * NCPHUOC 05/04/2022
     */
    submitGridEditor() {
      try {
        const me = this,
          {_gridDetails} = me;
        const submitAction = [];
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              const keyRef = _gridDetails[key];
              const $gridRef = me.$refs[keyRef];
              if ($gridRef && typeof $gridRef.submitEditor === 'function') {
                submitAction.push($gridRef.submitEditor());
              }
            }
          }
        }

        return Promise.all(submitAction);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Thực hiện nhấn nạp lại chứng từ
     * HTHIEP 12.04.2022
     */
    refresh() {
      const config = this.$store.getters[`${this.module}/_config`];
      if (config) {
        const {field} = config;
        if (field && field.key) {
          const id = this.model[field.key];
          if (id) {
            this.view({id});
          }
        }
      }
    },
    /**
     * NCPHUOC 21/04/2022
     * @override Xử lý validate grid
     * @returns true => validate pass, false => validate not pass
     * NXCHIEN 17.11.2023: trường hợp có trả về thông báo thi focus vào lỗi sau khi trả về thông báo, ko có thì focus luôn.
     */
    validateComponents(mode) {
      const me = this;
      let valid = this.super('validateComponents', baseDetailPopup);
      if (valid) {
        const validateGrids = this.validateGrid(mode);
        valid = !validateGrids.some(x => x);
      } else {
        nextTick(() => {
          me.focusFirstError();
        });
      }
      return valid;
    },
    /**
     * Xử lý validate các grid trên form chứng từ
     * @returns []=> Chứa message error của các grid
     * Modified by NVTUAN1 26.07.2023: Custom lại validate grid để cảnh báo được nhiều rule validate trên grid (bug 363214)
     */
    validateGrid() {
      const me = this;
      let messages = [];
      for (const key in me._gridDetails) {
        const refKey = me._gridDetails[key];
        const $refGrid = me.$refs[refKey];
        //Lấy ra template ref của grid
        if ($refGrid && typeof $refGrid.validate === 'function') {
          //Kết quả validate grid trả về
          let result = $refGrid.validate();
          //Trường hợp trả về mảng kết quả thì concat còn không thì vẫn như cũ
          if (result) {
            if (Array.isArray(result)) {
              messages = messages.concat(result);
            } else {
              messages.push(result);
            }
          }
        }
      }

      let message = me.customMessageValidateGrid(messages);
      let scope = me.$el;
      if (message) {
        showError(message, me.$tm('i18nBaseForm.Message.FailSave')).then(() => {
          nextTick(() => {
            me.focusFirstError(scope);
          });
        });
      }
      return messages;
    },

    /**
     * Custom message validate grid
     * @returns Nội dung message error của các grid
     * NVTUAN1 27.07.2023
     */
    customMessageValidateGrid(messages) {
      const me = this;

      //Rule ngày trước chỉ lấy ra thằng đầu tiên lỗi vẫn giữ nguyên không thay đổi gì
      let message = messages.find(x => x);

      if (message && typeof message === 'object' && message.message) {
        message.title = me.$tm('i18nBaseForm.Message.FailSave');
      }

      return message;
    },

    /**
     * Reset toàn bộ validate trên form
     * NCPHUOC 21/04/2022
     */
    resetValidate() {
      const me = this;
      me.super('resetValidate', baseDetailPopup);
      for (const key in me._gridDetails) {
        const refKey = me._gridDetails[key];
        const $refGrid = me.$refs[refKey];
        //Lấy ra template ref của grid
        if ($refGrid && typeof $refGrid.resetValidate === 'function') {
          $refGrid.resetValidate();
        }
      }
    },

    /**
     * @override
     * Khi chuyển về view sẽ gọi init nút in
     * NVTUAN1 07.02.2023: Bổ sung hàm xử lý trước khi set form mode
     */
    setFormMode(mode) {
      const me = this;

      me.beforeSetFormMode(mode);

      me.super('setFormMode', baseDetailPopup, mode);

      //Do load trước nên k muốn dính ngoại lệ chỗ này ảnh hưởng đến flow binding
      if (mode == me.$ms.constant.FormState.View && me.model.ref_type) {
        try {
          me.loadPrintMenu(me.model.ref_type);
        } catch (err) {
          console.error(err);
        }
      }

      if (this.model?.updateSynchronousTypeOffline) {
        this.editMode = me.$ms.constant.FormState.Add;
      }
    },
    reloadPrintMenu() {
      const me = this;
      if (me.model.ref_type) {
        try {
          me.loadPrintMenu(me.model.ref_type);
        } catch (err) {
          console.error(err);
        }
      }
    },
    /**
     * NVTUAN1 07.02.2023
     * Thực hiện check quyền sửa trước khi set form mode
     */
    beforeSetFormMode(mode) {
      const me = this;
      //Nếu là mode sửa thì check quyền sửa
      if (mode === me.$ms.constant.FormState.Edit) {
        me.checkActionPermissionAlert(me.$ms.constant.Permission.Edit);
      }
    },
    /**
     * Mở form tham số
     * NCPHUOC 19/08/2022: Thêm tham số cần thiết
     */
    async printItemCLick(report) {
      // check quyền In
      const me = this;
      let newReport = me.getReportConfig(report.ref_type, report.report_id);
      if (newReport) {
        report = me.getReportConfig(report.ref_type, report.report_id);
      }

      // nvtoan2 19/12/2023: Tạo ra 1 cái key để xác định reload báo cáo tại vị trí
      // Cái số nhân kia là số linh tinh thôi, chọn số nào cũng dc
      report.KeyReload = Math.floor(Math.random() * 110720) + '';

      this.checkActionPermissionAlert(this.$ms.constant.Permission.Print);
      // Lấy thông tin settingPrintConfig
      commonFunction.handleBindSettingReportToPrint(report.ref_type, report, me.dbOptions, report);
      /**
       * Đối với form tham số báo cáo, có tùy chọn là "không hiển thị lần sau"
       * tùy chọn này lưu trong db option
       * trước khi show form tham số(nếu có) thì kiểm tra xem option này có được chọn không
       * nếu được chọn là không hiển thị lần sau thì không show nữa
       * nxhoa 6.11.2023
       */
      let isShowFormParam = await this.checkShowReportParamByName(report);
      if (me.offlineReady) {
        // Nếu là mất mạng thì show form
        if (report.input_type_name) {
          // Nếu có config form tham số => mwor form tham số chọn
          popupUtil.show(report.input_type_name, {
            report: report,
            dataVoucher: this._formParam,
            dataModel: this.model,
          });
        } else {
          popupUtil.show('ReportOfflineDesigner', {
            report: report,
            dataVoucher: this._formParam,
            dataModel: this.model,
          });
        }
      } else if (report && report.input_type_name) {
        let contentTransferKey = '';
        if (me._gridDetails) {
          for (const key in me._gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(me._gridDetails, key)) {
              const element = me._gridDetails[key];
              if (element === 'refDetail') {
                contentTransferKey = key;
                break;
              }
            }
          }
        }
        let paramAddition = {};
        const customParams = me.getCustomReportParams(report.report_id);
        if (customParams) {
          paramAddition.DataParam = {...paramAddition.DataParam, ...customParams};
        }

        const templateParams = me.getTemplateParams(report.report_id);
        if (templateParams) {
          paramAddition.TemplateParam = {...templateParams};
        }
        let backRouter = this.getBackRouter();

        if (report && report.report_id == 'SettingPrint') {
          popupUtil.show(report.input_type_name, {
            ...report,
            ...this.model,
            ...paramAddition,
            ...{
              detailKey: contentTransferKey,
              backRouter: backRouter,
              submit: this.reloadPrintMenu,
              detailForm: this.$options?.name,
              options: {customParam: this.getCustomReportParams},
              fromReportSetting: true,
              module: this.module,
            },
          });
        } else if (report && report.report_id == 'PrintBatch') {
          let param = this._formParam;
          const formReportSetting = commonFunction.formChooseReportSettingFactory(report.ref_type);
          popupUtil.show(formReportSetting, {
            ...report,
            ...this.model,
            ...param,
            ...paramAddition,
            model: report,
            ...{
              detailForm: this.$options?.name,
              module: this.module,
            },
            options: {
              close: () => {
                me.reloadPrintMenu();
              },
            },
          });
        } else if (report && report.report_id == 'UNCMauTron') {
          // Show form mẫu trộn ủy nhiệm chi
          popupUtil.show('ReportMergePopup', {
            ...this.model,
            model: report,
            ...{
              detailForm: this.$options?.name,
              module: this.module,
            },
            options: {
              close: () => {
                me.reloadPrintMenu();
              },
            },
          });
        } else if (report && report.report_id == 'GNTMauTron') {
          // Show form mẫu trộn ủy nhiệm chi
          popupUtil.show('ReportMergePopup', {
            ...this.model,
            model: report,
            ...{
              detailForm: this.$options?.name,
              module: this.module,
            },
            options: {
              close: () => {
                me.reloadPrintMenu();
              },
            },
          });
        } else if (report && report.input_type_name === 'ReportParam_UNC') {
          // Mẫu UNC Stimul sẽ được check vào đây và ẩn hiện tham số
          let hideForm = false;
          let hideFormParamUNC = me.$ms.commonFn.getLocalStorage('HideFormParamUNC');
          if (hideFormParamUNC === null) {
            hideForm = me.dbOptions.HideFormParamUNC;
          } else {
            hideForm = hideFormParamUNC === 'true' ? true : false;
          }

          // Lấy giá trị param trong index Db để gán tham số cho form mở lên
          var indexDb = new IndexedDB();
          var surfixName = 'ReportParam_UNC';
          var formName =
            surfixName +
            '_' +
            (this.model.ref_id ?? '') +
            '_' +
            (report.ref_type ?? '') +
            '_' +
            (report.report_id ?? '');
          var recentData = await indexDb.get(formName);
          if (hideForm) {
            report = {...report, ...recentData};
            if (this.model) {
              if (
                'ref_id' in this.model &&
                'ref_no' in this.model &&
                'ref_type' in this.model &&
                'ref_date' in this.model &&
                'journal_memo' in this.model &&
                'total_amount' in this.model
              ) {
                let obj = {
                  ref_id: this.model.ref_id,
                  ref_no: this.model.ref_no,
                  ref_type: this.model.ref_type,
                  ref_date: this.model.ref_date,
                  journal_memo: this.model.journal_memo,
                  total_amount: this.model.total_amount,
                  payment_name: recentData?.payment_name ?? this.$store?.state?.context?.Context?.TenantName,
                };
                report = {...report, ...obj};
              }
            }
            this.printVoucher(report);
          } else {
            popupUtil.show('ReportParam_UNC', {
              ...report,
              ...this.model,
              ...paramAddition,
              ...{backRouter: backRouter},
              ...{
                detailForm: this.$options?.name,
                module: this.module,
              },
            });
          }
        } else {
          if (report && report.allow_batch_printing) {
            let param = this._formParam;
            const formReportSetting = commonFunction.formChooseReportSettingFactory(report.ref_type);
            popupUtil.show(formReportSetting, {
              ...report,
              ...this.model,
              ...param,
              ...paramAddition,
              model: report,
              ...{
                detailForm: this.$options?.name,
                module: this.module,
              },
            });
          } else {
            popupUtil.show(report.input_type_name, {
              ...report,
              ...this.model,
              ...paramAddition,
              ...{detailKey: contentTransferKey},
              ...{backRouter: backRouter},
              ...{
                detailForm: this.$options?.name,
                module: this.module,
              },
              options: {
                close: () => {
                  me.reloadPrintMenu();
                },
              },
            });
          }
        }
        this.pushTrans(this.$ms.constant.Command.Ok, true, report);
      } else {
        let paramAddition = {};
        const customParams = me.getCustomReportParams(report.report_id);
        if (customParams) {
          paramAddition.DataParam = {...paramAddition.DataParam, ...customParams};
        }

        const templateParams = me.getTemplateParams(report.report_id);
        if (templateParams) {
          paramAddition.TemplateParam = {...templateParams};
        }
        let backRouter = this.getBackRouter();
        // Xử lý mẫu UNC, merge excel tại đây
        // Lấy ra cache theo id truyền vào
        // Kiểm tra xem trong localStorage trước
        // Nếu không có thì lấy dboption
        let hideForm = false;
        let hideFormParamUNC = me.$ms.commonFn.getLocalStorage('HideFormParamUNC');
        if (hideFormParamUNC === null) {
          hideForm = me.dbOptions.HideFormParamUNC;
        } else {
          hideForm = hideFormParamUNC === 'true' ? true : false;
        }

        // Lấy giá trị param trong index Db để gán tham số cho form mở lên
        var indexDb = new IndexedDB();
        var surfixName = '';
        if (report && report.report_type == this.$ms.constant.ReportType.UNCMergeReport) {
          surfixName = 'ReportParam_UNC_Excel';
        } else {
          surfixName = 'ReportParam_UNC';
        }
        var formName =
          surfixName + '_' + (this.model.ref_id ?? '') + '_' + (report.ref_type ?? '') + '_' + (report.report_id ?? '');
        // var formName = surfixName + '_' + (report.ref_type ?? '') + '_' + (report.report_id ?? '');
        var recentData = await indexDb.get(formName);

        //HMDUC2: 17/07/2024 Truyền thêm tham số IsNotShowFormNextTime - Bug 464145
        if (report !== null) {
          report.IsNotShowFormNextTime = !isShowFormParam;
        }

        // DVMINH 11/09/2023 Đoạn này để xử lý bật form tham số của mẫu merge/excel
        if (report && report.report_type == this.$ms.constant.ReportType.UNCMergeReport) {
          if (hideForm) {
            report = {...report, ...recentData};
            if (this.model) {
              if (
                'ref_id' in this.model &&
                'ref_no' in this.model &&
                'ref_type' in this.model &&
                'ref_date' in this.model &&
                'journal_memo' in this.model &&
                'total_amount' in this.model
              ) {
                let obj = {
                  ref_id: this.model.ref_id,
                  ref_no: this.model.ref_no,
                  ref_type: this.model.ref_type,
                  ref_date: this.model.ref_date,
                  journal_memo: this.model.journal_memo,
                  total_amount: this.model.total_amount,
                  payment_name: recentData?.payment_name ?? this.$store?.state?.context?.Context?.TenantName,
                };
                report = {...report, ...obj};
              }
            }
            this.printMergeReport(report);
          } else {
            let param = {
              ReportId: report.report_id,
              ReportName: report.report_name,
              ReportList: report,
              DataParam: {
                refIds: [me.model.ref_id || report?.ref_id],
                $ListRefID: report?.list_ref_id || me.model.ref_id || report?.ref_id,
                $RefType: report?.ref_type,
                ViewReceiptFullAmount: report?.view_receipt_full_amount,
                PrintInfomationReceiptUnit: report?.print_information_receipt_unit,
                PrintSystemDate: report?.print_system_date,
                PrintVourcherDate: report?.print_voucher_date,
                PrintPreview: report?.print_voucher_preview,
                AllowBatchPrinting: report?.allow_batch_printing,
                DateTimeReport: report?.print_system_date ? me.postedDate : null,
                $PrintedType: report?.printed_type || 2,
                $OrderBy: report?.order_by || '',
                ReportType: this.$ms.constant.ReportType.UNCMergeReport,
              },
            };
            popupUtil.show('ReportParam_UNC_Excel', {
              ...report,
              ...this.model,
              ...param,
              ...{backRouter: backRouter},
              ...{
                detailForm: this.$options?.name,
                module: this.module,
              },
            });
          }
        } else {
          // Chỉ in mẫu UNC
          this.printVoucher(report);
        }
      }
    },
    /**
     * In lại mẫu in gần nhất
     * NBTIN 14.12.2023
     */
    async printPreviousReport(e, toggleMenu, toggleMainMenu) {
      const me = this;
      var user_id = me.Context.UserID;
      var ref_type = me.model.ref_type;
      var database_id = me.Context.DatabaseId;
      var keyCachePrint = `previous_print_${database_id}_${user_id}_${ref_type}`;
      var cacheKeyShowOption = `IsDisplayPrintOption_${database_id}_${user_id}_${ref_type}`;
      var isDisplayPrintOption = me.$ms.commonFn.getSessionStorage(cacheKeyShowOption);
      var report = {};
      if (keyCachePrint) {
        report = JSON.parse(commonFunction.getSessionStorage(keyCachePrint));
        if (report) {
          if (isDisplayPrintOption === 'false') {
            await me.printItemCLick(report);
          } else {
            toggleMainMenu(e, toggleMenu);
          }
        } else {
          voucherReportPrintAPI
            .getPreviousReport({
              ref_type: ref_type,
              user_id: user_id,
            })
            .then(async res => {
              if (res?.report_id) {
                await me.printItemCLick(res);
              } else {
                toggleMainMenu(e, toggleMenu);
              }
            });
        }
      }
    },
    /**
     * Kiểm tra hiển thị form tham số
     * đối với những form tham số có tùy chọn "không hiển thị lần sau"
     * nxhoa 3.11.2023
     */
    async checkShowReportParamByName(report) {
      let isShow = true;
      if (!report || !report.input_type_name) {
        return isShow;
      }

      let isNeedCheck = false;
      let keyCache = null;
      switch (report.input_type_name) {
        case this.$ms.constant.ReportInputTypeName.ReportParamC40BB:
        case this.$ms.constant.ReportInputTypeName.ReportParamC41BB:
          isNeedCheck = true;
          let reportName = commonFunction.removeVietnameseTones(report.report_name).replace(/[^a-zA-Z0-9]/g, '');
          keyCache = `${report.input_type_name}_${reportName}`;
          break;
        default:
          keyCache = report.input_type_name;
          break;
      }

      if (!isNeedCheck) {
        return isShow;
      }

      /**
       * Kiểm tra hiển thị form tham số (đối với những form tham số có tùy chọn không hiển thị lần sau)
       * Lấy tùy chọn trong indexDb trước, nếu có thì sử dụng luôn
       * nếu không có thì lấy trong DB option
       * Giải pháp: nếu tùy chọn ẩn thì xóa tên form tham số đi không show lên nữa
       * nxhoa 6.11.2023
       */
      let dbOptionKey = this.$ms.constant.DbOptionKey.IsNotShowFormNextTime;
      //nxhoa 7.11.2023 thêm index db để lấy một số tùy chọn theo form
      this._indexDb = this._indexDb || new IndexedDB();
      let cacheParam = await this._indexDb.get(keyCache);

      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (cacheParam && typeof cacheParam == 'object' && cacheParam.hasOwnProperty(dbOptionKey)) {
        isShow = !(cacheParam[dbOptionKey] == true);
      } else {
        let rawValue = this.dbOptions[dbOptionKey] || '{}';

        try {
          let optionValue = JSON.parse(rawValue);
          let value = optionValue[keyCache];
          isShow = !(value == true);
        } catch (e) {
          console.log(e);
        }
      }

      report.input_type_name = isShow ? report.input_type_name : '';
      return isShow;
    },

    /**
     * Lấy Backrouter dùng cho in chứng từ có Drilldown
     */
    getBackRouter() {
      return '/popup/' + this._formParam.name.toLowerCase() + '/' + this.model.ref_id.split('-').join('.');
    },

    /**
     * in chứng từ
     * DVMINH 13/09/2023 thêm biến để show form tham số chứng từ UNC
     */
    async printVoucher(report, isOption = false) {
      const me = this;
      if (!report || !report.report_id) {
        return;
      }
      if (isOption) {
        report = me.customReport(report);

        popupUtil.show('ReportParam_UNC', {
          ...report,
          ...me.model,
        });
      } else {
        // Bổ sung thêm thông tin của tùy chọn in
        let param = {
          ReportId: report.report_id,
          ReportName: report.report_name,
          // ReportTitle: report.report_name,
          // ReportSubTitle: report.report_name,
          ReportList: report,
          DataParam: {
            refIds: [me.model.ref_id || report?.ref_id],
            $ListRefID: report?.list_ref_id || me.model.ref_id || report?.ref_id,
            $RefType: report?.ref_type,
            ViewReceiptFullAmount: report?.view_receipt_full_amount,
            PrintInfomationReceiptUnit: report?.print_information_receipt_unit,
            PrintSystemDate: report?.print_system_date,
            PrintVourcherDate: report?.print_voucher_date,
            PrintPreview: report?.print_voucher_preview,
            AllowBatchPrinting: report?.allow_batch_printing,
            DateTimeReport: report?.print_system_date ? me.postedDate : null,
            $PrintedType: report?.printed_type || 2,
            $OrderBy: report?.order_by || '',
            payment_name: report?.payment_name,
            receiveMoney: report?.receiveMoney,
            payer_name: report?.payer_name,
            IsNotShowFormNextTime: report?.IsNotShowFormNextTime,
          },
        };
        const customParams = me.getCustomReportParams(report.report_id);
        if (customParams) {
          param.DataParam = {...param.DataParam, ...customParams};
        }
        if (report.is_hide_later) {
          param.DataParam.payment_name = report.payment_name;
        }
        const templateParams = me.getTemplateParams(report.report_id);
        if (templateParams) {
          param.TemplateParam = {...templateParams};
        }
        report = me.customReport(report);
        if (report && report.allow_batch_printing) {
          const formReportSetting = commonFunction.formChooseReportSettingFactory(report.ref_type);
          popupUtil.show(formReportSetting, {
            ...report,
            ...me.model,
            model: report,
            ...{
              detailForm: this.$options?.name,
            },
            ...param,
          });
        } else {
          // Thực hiện lưu luôn thông tin đã in với những chứng từ in luôn
          commonFunction.savePrintSingleReportConfigPrint(report, me.model);
          await me.setSettingPrintParam(report, param);
          me.print(report, param);
          me.pushTrans(this.$ms.constant.Command.Ok, true, report);
        }
      }
    },

    // Lấy setting tùy chọn in cho báo cáo khong có tham số
    async setSettingPrintParam(report, param) {
      const me = this;
      var data = await me.loadRecentData(report);
      param.IsSaveCommon = true;
      param.ReportIdCommon = report.report_file;
      param.DataParam.settingOptions = data?.settingOptions;
      param.DataParam.paramReportCommon = {
        settingOptions: data?.settingOptions,
      };
    },
    // Load tùy chọn in gần nhất
    async loadRecentData(report) {
      //TODO
      const me = this;
      const refType = report.ref_type,
        reportId = report.report_id,
        paramKey = `${this._formParam?.ref_id}`,
        reportIdCommon = me.reportIdCommon || report.report_file; //Id chung cho báo cáo (mẫu ngang, mẫu dọc, ...)
      let data = {};
      const res = await api.getRecentParam(paramKey, refType, reportId, reportIdCommon);
      const {detailKey} = me._formParam;
      if (res) {
        const {common} = res;
        if (common) {
          Object.assign(data, JSON.parse(common));
        }
      }
      return data;
    },

    /**
     * Xử lý in báo cáo mẫu merge
     * npcuong 05.01.2022
     * DVMINH 13/09/2023 Bổ sung thêm điều kiện để in mẫu merge với form tham số
     */
    async printMergeReport(report, isOption = false) {
      const me = this;
      if (!report || !report.report_id) {
        return;
      }
      if (isOption) {
        let param = {
          ReportId: report.report_id,
          ReportName: report.report_name,
          ReportList: report,
          DataParam: {
            refIds: [me.model.ref_id || report?.ref_id],
            $ListRefID: report?.list_ref_id || me.model.ref_id || report?.ref_id,
            $RefType: report?.ref_type,
            ViewReceiptFullAmount: report?.view_receipt_full_amount,
            PrintInfomationReceiptUnit: report?.print_information_receipt_unit,
            PrintSystemDate: report?.print_system_date,
            PrintVourcherDate: report?.print_voucher_date,
            PrintPreview: report?.print_voucher_preview,
            AllowBatchPrinting: report?.allow_batch_printing,
            DateTimeReport: report?.print_system_date ? me.postedDate : null,
            $PrintedType: report?.printed_type || 2,
            $OrderBy: report?.order_by || '',
            ReportType: this.$ms.constant.ReportType.UNCMergeReport,
          },
        };
        popupUtil.show('ReportParam_UNC_Excel', {
          ...report,
          ...this.model,
          ...param,
        });
      } else {
        let param = {
          ReportId: report.report_id,
          ReportName: report.report_name,
          ReportList: report,
          DataParam: {
            refIds: [me.model.ref_id || report?.ref_id],
            $ListRefID: report?.list_ref_id || me.model.ref_id || report?.ref_id,
            $RefType: report?.ref_type,
            ViewReceiptFullAmount: report?.view_receipt_full_amount,
            PrintInfomationReceiptUnit: report?.print_information_receipt_unit,
            PrintSystemDate: report?.print_system_date,
            PrintVourcherDate: report?.print_voucher_date,
            PrintPreview: report?.print_voucher_preview,
            AllowBatchPrinting: report?.allow_batch_printing,
            DateTimeReport: report?.print_system_date ? me.postedDate : null,
            $PrintedType: report?.printed_type || 2,
            $OrderBy: report?.order_by || '',
            ReportType: report?.report_type,
            payment_name: report?.payment_name,
            is_hide_later: report?.is_hide_later,
            name: report?.name,
            reportName: report?.reportName,
          },
        };
        param.IsPreviewFile = true;
        me.print(report, param);
      }
    },

    /**
     * Custom thêm param cho report
     * tvhien 22.08.2022
     */
    customReport(report) {
      if (report && report.report_name) {
        report.reportName = report.report_name;
      }
      return report;
    },

    /**
     * Khai báo templateParam phục việc dùng trên stimul
     * tvhien 15.08.2022
     */
    getTemplateParams(reportId) {
      return null;
    },

    /**
     * Khai báo custom params
     */
    getCustomReportParams(reportId) {
      return null;
    },

    /**
     * Binding mặc định detail cho các trường hợp grid ko có data
     * @param {Object} data model binding trên form
     * NCPHUOC 27/04/2022
     */
    bindingDetail(data) {
      const me = this;
      const {_gridDetails} = this;
      const detailKeys = Object.keys(_gridDetails);
      const defaultRow = this._defaultRow != null && this._defaultRow !== undefined ? this._defaultRow : 3;
      if (detailKeys.length > 0) {
        detailKeys.forEach(key => {
          data[key];

          if (!Array.isArray(data[key]) || data[key].length === 0) {
            const arr = [];
            for (let index = 0; index < defaultRow; index++) {
              const emptyRow = {state: this.$ms.constant.ModelState.Empty};
              arr.push(emptyRow);
            }
            data[key] = arr;
          }
          //TVDAT 27/07/2022: Chỗ này sort lại dữ liệu trong các grid detail theo sort_order
          //NVTUAN1 28.09.2022: Tạo hàm sortGridDetail để dev override thực hiện sort tùy theo nghiệp vụ từng màn hình
          if (data[key] && Array.isArray(data[key])) {
            me.sortGridDetail(data[key]);
          }
        });
      }
    },
    /**
     * Thực hiện sort dữ liệu trong grid detail (mặc định theo sort_order)
     * DEV muốn sort theo các trường dữ liệu khác thì override lại hàm này
     * NVTUAN1 28.09.2022
     */
    sortGridDetail(data) {
      const me = this;
      data.sortObject('sort_order');
    },

    /**
     * Custom data trước khi mở form thêm mới
     * @param {*} data
     * NXCHIEN 29.04.2022
     * Modified by NVTUAN1 05.08.2022: Xử lý dữ liệu binding khi nhân bản
     */
    beforeBinding(data, mode, param) {
      const me = this;
      me.super('beforeBinding', baseDetailPopup, data, mode);

      switch (mode) {
        case me.$ms.constant.FormState.Add:
          //gắn lại tham số ẩn hiện thông tin chung khi thêm mới mặc định = true
          if (!me.toggleAbove) {
            me.toggleAbove = true;
          }
          if (me._formParam && me._formParam.data && me._formParam.data.IsGenerateData) {
            return;
          }
          // Thêm ngày CT, ngày HT (mode Add: nếu là không phải là phục hồi chứng từ gán lại)
          if (!me?.isRestoreVoucher) {
            data['posted_date'] = this.postedDate;
            data['ref_date'] = this.postedDate;
          }
          break;
        case me.$ms.constant.FormState.Duplicate:
          //gắn lại tham số ẩn hiện thông tin chung khi thêm mới mặc định = true
          if (!me.toggleAbove) {
            me.toggleAbove = true;
          }
          //Không nhân bản ref_order để các chứng từ chuyển kho/xuất kho... lấy được đúng số tồn mới nhất
          data.ref_order = null;

          // Thêm ngày CT, ngày HT
          data['posted_date'] = this.postedDate;
          data['ref_date'] = this.postedDate;

          // Gán một số trường về null để không bị lỗi khi sử dụng các chức năng khác. VD: Sinh hạch toán đồng thời,...
          if (data && Array.isArray(data.Parallels) && data.Parallels.length > 0) {
            data.Parallels.forEach(x => {
              x[me.$ms.constant.ColumnCommon.orgRefDetailId] = null;
            });
          }

          //truyền thêm id chứng từ gốc vào _formParm để xử lý cho nhân bản tham số in chứng từ gốc
          if (param && param.id && me._formParam) {
            me._formParam.id = param.id;
          }
          break;
        default:
          break;
      }
    },

    /**
     * Lấy dữ liệu cất: Bổ sung thêm ref_type
     * NOTE: 1 form Detail có 2 refType thì cần override để truyền lại reftype
     * NXCHIEN 13.05.2022
     * */
    getSaveData(mode, action) {
      let me = this;
      let data = me.super('getSaveData', baseDetailPopup, mode, action);
      let formDetail = me._formParam.name.substring(0, me._formParam.name.length - 6);

      // lấy ra giá trị ref_type
      if (formDetail) {
        data.ref_type = me.$ms.constant.RefType[formDetail];
        data.refTypes = {RefTypeKey: me.$ms.constant.RefType[formDetail]};
      }

      // Đánh STT cho các dòng chi tiết
      if (me._gridDetails) {
        Object.keys(me._gridDetails).forEach(item => {
          me.assignSortOrder(data[item]);
        });
      }

      return data;
    },

    /**
     * Đánh STT cho dữ liệu chi tiết
     * NXCHIEN 24.07.2022
     * Modified TVDAT 03/08/2022
     */
    assignSortOrder(data) {
      const me = this;
      if (data && data.length > 0) {
        let j = 0;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (item.state != me.$ms.constant.ModelState.Delete && item.state != me.$ms.constant.ModelState.Empty) {
            item.sort_order = j;
            if (item.state == me.$ms.constant.ModelState.None) {
              item.state = me.$ms.constant.ModelState.Update;
            }
            j++;
          }
        }
      }

      return data;
    },

    /**
     * Xử lý sau khi xóa
     * NXCHIEN 16.07.2022
     * Modified by NVTUAN1: Sửa lại login ẩn hiện popop và thông báo khi xóa thành công
     */
    deleteSuccess(record, result) {
      const me = this;
      // xử lý validate chứng từ liên quan

      if (result && Array.isArray(result) && result.length) {
        let res = result[0]; // xóa 1 bản ghi nên lấy luôn giá trị đầu tiên
        if (
          res.Code === me.$ms.constant.PostedErrorCode.GENERATE_DATA &&
          res.Data &&
          res.Data.Data &&
          Object.keys(res.Data.Data).length > 0
        ) {
          me.super('deleteSuccess', baseDetailPopup, record, result);
          let mes = me.$tm('i18nBaseForm.Message.DeleteRelation');
          // res.Data.Data: Object chứa giá trị lỗi
          showConfirm(
            mes.format(res.Data.Data.ref_no, res.Data.Data.relation_ref_no),
            me.$tm('i18nBaseForm.Message.DeleteRelationTitle'),
          ).then(answer => {
            if (answer) {
              me.deleteRelation(res.Data, record, result);
              me.pushTrans(me.$ms.constant.Command.DeleteVoucherRelationWhenDeleteVoucherRoot);
            } else {
              if (me.options && typeof me.options.submit === 'function') {
                me.options.submit();
              }

              me.hide();
            }
          });
        } else if (
          res.Code === me.$ms.constant.PostedErrorCode.GENERATE_DATAS &&
          res.Data &&
          res.Data.Data &&
          Object.keys(res.Data.Data).length > 0
        ) {
          me.super('deleteSuccess', baseDetailPopup, record, result);
          let mes = me.$tm('i18nBaseForm.Message.DeleteRelations');
          // res.Data.Data: Object chứa giá trị lỗi
          showConfirm(
            mes.format(res.Data.Data[0]?.ref_no, res.Data.Data.map(x => x.relation_ref_no)?.join('; ')),
            me.$tm('i18nBaseForm.Message.DeleteRelationTitle'),
          ).then(answer => {
            if (answer) {
              me.deleteRelations(res.Data, record, result);
              me.pushTrans(me.$ms.constant.Command.DeleteVoucherRelationWhenDeleteVoucherRoot);
            } else {
              if (me.options && typeof me.options.submit === 'function') {
                me.options.submit();
              }

              me.hide();
            }
          });
        } else {
          console.error('Lỗi xóa không thành công');
        }
      } else {
        me.hide();
        // Thêm sự kiện gọi đến submit
        if (me.options && typeof me.options.submit === 'function') {
          me.options.submit(record);
        }
        // Sự kiện xóa chứng từ sau khi sinh chừng từ quản lý tài sản
        if (me.options && typeof me.options.deleteAssetVoucher === 'function') {
          me.options.deleteAssetVoucher(record);
        }
        me.super('deleteSuccess', baseDetailPopup, record, result);
      }
    },

    /**
     * Xóa dữ liệu liên quan thực hiện trên form riêng
     * NXCHIEN 19.07.2022
     * Modified by NVTUAN1: Sửa lại login ẩn hiện popop và thông báo khi xóa thành công
     */
    deleteRelation(data, record, result, ignore) {
      // Call API xóa dữ liệu
      const me = this;
      let param = [
        {
          RefId: data.Data.relation_ref_id,
          RefType: data.Data.relation_ref_type,
          Ignores: ['string'],
        },
      ];

      if (ignore) {
        param[0].Ignores.push(ignore);
      }

      me.$store
        .dispatch(`${me.module}/deleteRelation`, param)
        .then(res => {
          // xử lý cảnh báo nếu xóa ko được hoặc bỏ ghi ko được
          if (res && Array.isArray(res) && res.length) {
            if (res.find(x => x.Code == me.$ms.constant.PostedErrorCode.VALIDATE)) {
              me.deleteRelationError(res, param, data, record, result);
            } else {
              console.error('Lỗi xóa không thành công');
            }
          } else {
            //Xóa bản ghi ở màn hình danh sách
            me.afterDeleteRelation(param);
            //Ẩn tất cả popup đang mở để trở về màn hình danh sách ban đầu
            popupUtil.hideAll();
            //Show câu thông báo xóa thành công
            me.super('deleteSuccess', baseDetailPopup, record, result);
          }
        })
        .catch(ex => {});
    },

    /**
     * Xóa dữ liệu các chứng từ đích
     * dqdat1 06.03.2024
     */
    deleteRelations(data, record, result, ignore) {
      // Call API xóa dữ liệu
      const me = this;
      let param = [];
      data.Data.forEach(item => {
        param.push({
          RefId: item.relation_ref_id,
          RefType: item.relation_ref_type,
          Ignores: ['string'],
        });
      });

      if (ignore) {
        param[0].Ignores.push(ignore);
      }

      me.$store
        .dispatch(`${me.module}/deleteRelation`, param)
        .then(res => {
          // xử lý cảnh báo nếu xóa ko được hoặc bỏ ghi ko được
          if (res && Array.isArray(res) && res.length) {
            if (res.find(x => x.Code == me.$ms.constant.PostedErrorCode.VALIDATE)) {
              me.deleteRelationError(res, param, data, record, result);
            } else {
              console.error('Lỗi xóa không thành công');
            }
          } else {
            //Xóa bản ghi ở màn hình danh sách
            me.afterDeleteRelation(param);
            //Ẩn tất cả popup đang mở để trở về màn hình danh sách ban đầu
            popupUtil.hideAll();
            //Show câu thông báo xóa thành công
            me.super('deleteSuccess', baseDetailPopup, record, result);
          }
        })
        .catch(ex => {});
    },

    /**
     * Cập nhật danh sách bên ngoài sau khi xóa bản ghi liên quan bên trong màn hình chi tiết
     * @param {*} param
     * NVTUAN1 26.07.2022
     */
    afterDeleteRelation(param) {
      //TODO DEV tự override hàm này ở màn hình chứng từ của mình để thực hiện cập nhật danh sách sau khi xóa chứng từ liên quan
    },

    /**
     * Lỗi bỏ ghi chứng từ khi xóa
     * NXCHIEN 20.07.2022
     */
    deleteRelationError(res, param, dataVoucherCallback, recordCallBack, resultCallBack) {
      const me = this;

      if (res && Array.isArray(res) && res.length) {
        let item = res[0]; // item: Lỗi khi xóa chứng từ liên quan: Bỏ ghi gây ra lỗi
        switch (item.Code) {
          case me.$ms.constant.PostedErrorCode.VALIDATE:
            if (item.Data && item.Data.Data) {
              let dataError = item.Data.Data;

              // Có mã lỗi là Error và Question
              if (
                item.Data.Type == me.$ms.constant.PostedErrorType.Error &&
                item.Data.Code == me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Code
              ) {
                // Chứng từ đã được lập bảng kê và đã thanh toán
                me.processErrorVoucherList(dataError);
              } else if (item.Data.Type == me.$ms.constant.PostedErrorType.Question) {
                switch (item.Data.Code) {
                  case me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Code:
                    // Chứng từ đã lập chứng từ ghi sổ hoặc bảng tổng hợp
                    me.processQuestionVoucherSummary(
                      dataError,
                      dataVoucherCallback,
                      recordCallBack,
                      resultCallBack,
                      item.Data.Code,
                    );
                    break;

                  // case me.$ms.constant.PostedErrorCode
                  //   .UnPost_Warning_OutwardBeUpdated:
                  //   // Lỗi phần Kho
                  //   me.processQuestionOutWard(dataError, item);
                  //   break;
                }
              }
            }
            break;

          default:
            showError(me.$tm('i18nBaseForm.Message.Exception'), 'Cảnh báo');
            break;
        }
      }
    },

    /**
     * Xử lý lỗi chứng từ đã lên bảng kê và đã thanh toán
     * NXCHIEN 21.07.2022
     */
    processErrorVoucherList(dataError) {
      const me = this;
      // build thông báo chứng từ lên bảng kê và đã thanh toán
      let code = dataError.map(x => x.exception_ref_no).join('; ');
      let mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Multi.format(code);

      // Hiển thị bảng kê
      // Click vào bảng kê nào thì hiển thị ra bảng kê đó
      // TODO Vẽ popup để bind sự kiện: Tạm thời để show thằng đầu tiên
      let button = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Button;
      showConfirmValidateCustom(
        mes,
        me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Title,
        button,
      ).then(answer => {
        if (answer) {
          //Lấy form detail name  -- Tạm fix click vào bảng kê đầu tiên
          let formDetailName = me.getFormDetailName(dataError[0].exception_ref_type);
          // chọn xem bảng kê thì mở form bảng kê
          popupUtil.show(formDetailName, {
            mode: me.$ms.constant.FormState.View,
            id: dataError[0].exception_ref_id,
            data: dataError[0],
            options: {},
          });
        }
      });
    },

    /**
     * Xử lý lỗi chứng từ đã lập BTH hoặc chứng từ cùng loại
     * NXCHIEN 21.07.2022
     */
    processQuestionVoucherSummary(dataError, dataVoucherCallback, recordCallBack, resultCallBack, ErrorCode) {
      const me = this;
      let mes = '',
        dataSummary = dataError.filter(x => x.ref_type == me.$ms.constant.RefType.GLVoucherSummaryTable) || [],
        dataVoucher = dataError.filter(x => x.ref_type == me.$ms.constant.RefType.GLPostedVoucher) || [];
      // message chứng từ lên bảng tổng hợp
      let mesSummary = dataSummary.map(x => x.ref_no)?.join('; ');

      // message chứng từ lên chứng từ ghi sổ
      let mesVoucher = dataVoucher.map(x => x.ref_no)?.join('; ');

      if (dataSummary.length && dataVoucher.length) {
        //Trường hợp có cả ghi sổ và bảng th cùng loài
        mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_All.format(
          mesSummary,
          dataError[0].ref_no,
          mesVoucher,
        );
      } else if (dataSummary.length && dataVoucher.length == 0) {
        //Trường hợp chỉ có bảng tổng hợp
        mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Summary.format(
          mesSummary,
          dataError[0].ref_no,
        );
      } else if (dataSummary.length == 0 && dataVoucher.length) {
        //Trường hợp chỉ có ghi sổ
        mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Voucher.format(
          mesVoucher,
          dataError[0].ref_no,
        );
      }

      if (mes) {
        // Cảnh báo chứng từ đã lập BTH hoặc Chứng từ ghi sổ
        // Cho phép ignore qua cảnh báo này để bỏ ghi sổ khi thực hiện đồng ý
        showConfirm(mes, 'Cảnh báo bỏ ghi sổ').then(answer => {
          if (answer) {
            if (dataVoucherCallback?.Code == me.$ms.constant.PostedErrorCode.Delete_ErrorRelationVouchers) {
              me.deleteRelations(dataVoucherCallback, recordCallBack, resultCallBack, ErrorCode);
            } else {
              me.deleteRelation(dataVoucherCallback, recordCallBack, resultCallBack, ErrorCode);
            }
          }
        });
      } else {
        console.error('Lỗi thông báo chứng từ đã lập BTH hoặc chứng từ cùng loại');
      }
    },

    /**
     * Xử lý lỗi về kho
     * NXCHIEN 21.07.2022
     */
    processQuestionOutWard(dataError, item) {
      const me = this;
      let valRefNo = dataError.map(x => x.ref_no).join('; ');
      let mess = me.$ms.constant.PostedErrorCode[item.Data.Code].format(valRefNo);
      showConfirm(mess, 'Cảnh báo bỏ ghi sổ').then(answer => {
        if (answer) {
          me.deleteRelation(dataVoucherCallback, recordCallBack, resultCallBack, item.Data.Code);
        }
      });
    },

    /**
     * Hàm thực hiện set lấy thêm reftype để xử lý cho autoID
     * NXCHIEN 27.05.2022
     */
    customVoucherLoadData(result) {
      const me = this;
      me.super('customVoucherLoadData', baseDetailPopup, result);
      let formDetail = me._formParam.name.substring(0, me._formParam.name.length - 6);
      // lấy ra giá trị ref_type
      if (formDetail) {
        result.param = JSON.stringify({
          RefTypeKey: me.$ms.constant.RefType[formDetail],
        });
      }
    },
    /**
     * Lấy câu thông báo khi xóa (Sửa theo thiết kế)
     * NXCHIEN 05.06.2022
     * Modified TPNAM 10.02.2025 - escape các ký tự đặc biệt chống tấn công XSS
     */
    async getDeleteConfirmMessage(records) {
      const me = this;
      let mes = await me.super('getDeleteConfirmMessage', baseDetailPopup, records);
      if (mes && mes.title && mes.message) {
        mes.title = this.$tm('i18nBaseForm.Message.ConfirmDeleteVoucherTitle');
        mes.message = this.$tm('i18nBaseForm.Message.ConfirmDeleteVoucher');
        let keyCode = me.$store.state[me.module]._config.field.code;
        if (keyCode) {
          mes.message = mes.message.format(_.escape(records[keyCode]));
        } else {
          mes.message = mes.message.format('');
        }
      }

      return mes;
    },

    /**
     * custom lại columns để hiển thị thêm cột trên grid
     * NXCHIEN 12.06.2022
     */
    customColumns(columns) {},

    /**
     * Validate lỗi nghiệp vụ
     * Kiểm tra nhập ít nhất 1 dòng dữ liệu chi tiết tại gridDetail
     * NOTE khai báo gridDetail
     * NNLINH 06.06.2022
     */
    validateBusiness(saveParam, action) {
      // var me = this;
      // let mes = {};
      // if (me._gridDetails) {
      //   for (const key in me._gridDetails) {
      //     const detailData = me.model[key];
      //     if (Array.isArray(detailData) && me._gridDetails[key] === 'gridDetail') {
      //       let detail = detailData.find(x => x.state == this.$ms.constant.ModelState.Insert || x.state == this.$ms.constant.ModelState.Update || x.state == this.$ms.constant.ModelState.None);
      //       if (!detail) {
      //         mes = {
      //           title: this.$tm('i18nBaseForm.Message.ValidateBusinessTitle'),
      //           message: this.$tm('i18nBaseForm.Message.ValidateBusiness')
      //         }
      //       }
      //     }
      //   }
      // }
      return {};
    },

    /**
     * Validate ghi sổ
     * NXCHIEN 11.07.2022
     */
    async validatePosted() {
      const me = this;
      const detailKeys = Object.keys(me._gridDetails);
      let mes = {};
      if (detailKeys.length > 0) {
        // validate grid Hạch toán
        let key = detailKeys.find(x => me._gridDetails[x] == 'refDetail');
        if (key) {
          let detail = me.model[key]?.filter(x => x.state != me.$ms.constant.ModelState.Empty);
          // Type: 1: Các field đang để trống, 2: Chưa nhập dòng chi tiết, 3: số tiền = 0
          if (detail && detail.length > 0) {
            let mesVal = await me.validateAccounting();
            if (mesVal) {
              mes = {
                content: mesVal,
                type: 1,
                title: 'Ghi sổ không thành công',
              };
            } else {
              // Kiểm tra số tiền có = 0 thì cảnh báo
              mes = me.validateAmount(detail, key);
            }
          }
        }
      }

      return mes;
    },

    /**
     * Validate nghiệp vụ trước khi save
     * NXCHIEN 27.06.2022
     */
    validateBusinessBeforeSave() {
      const me = this;
      let mes = {};
      // Validate các trường thông tin nhập liệu(trường nhập liệu trên form)
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (
        me.model &&
        (me.model.hasOwnProperty('posted_date') ||
          me.model.hasOwnProperty('ref_date') ||
          me.model.hasOwnProperty('ref_type'))
      ) {
        let dateCheck = me.model['posted_date'] || me.model['ref_date'],
          txtPosted = '',
          reftype = me.model['ref_type'];
        if (me.model['posted_date']) {
          txtPosted = 'hạch toán';
        } else {
          txtPosted = 'chứng từ';
        }

        if (reftype != me.$ms.constant.RefType.SASaleInvoice) {
          if (me.postedDate && dateCheck && typeof dateCheck.getFullYear == 'function') {
            let dbStartDate = new Date(me.dbOptions.DBStartDate);
            if (me.dBDateClosed && typeof me.dBDateClosed.getFullYear == 'function') {
              if (me.$ms.commonFn.compareDate(dateCheck, me.dBDateClosed) !== 1) {
                mes = {
                  title: 'Không thể thực hiện',
                  content: `Ngày ${txtPosted} phải lớn hơn Ngày khóa sổ <span class="color-green">${moment(
                    new Date(me.dBDateClosed),
                  ).format('DD/MM/YYYY')}</span>`,
                };
                return mes;
              }
            }
            if (me.model.posted_date?.getFullYear() >= 2025 && this.context?.IsCreateTT24) {
              mes = {
                title: 'Ngày hạch toán không hợp lệ',
                content: `Từ ngày 01/01/2025, Thông tư 107/2017/TT-BTC hướng dẫn chế độ kế toán cho đơn vị HCSN được thay thế bởi Thông tư 24/2024/TT-BTC. Để hạch toán chứng từ phát sinh trong năm ${me.model.posted_date.getFullYear()}, bạn cần <b>Cập nhật Thông tư 24/2024/TT-BTC<b/>.`,
                showUpdateTT24: true,
              };
              return mes;
            } else if (dbStartDate.getFullYear() == me.postedDate.getFullYear()) {
              if (
                me.$ms.commonFn.compareDate(dbStartDate, dateCheck) == 1 ||
                me.$ms.commonFn.compareDate(dateCheck, new Date(me.postedDate.getFullYear(), 11, 31)) == 1
              ) {
                mes = {
                  title: `Ngày ${txtPosted} không hợp lệ`,
                  content: `Ngày ${txtPosted} phải nằm trong khoảng thời gian từ ngày <span class="color-green">${moment(
                    new Date(me.dbOptions.DBStartDate),
                  ).format('DD/MM/YYYY')}</span>
              đến <span class="color-green">31/12/${me.postedDate.getFullYear()}</span>. Vui lòng kiểm tra lại.`,
                };
                return mes;
              }
            } else {
              if (dateCheck.getFullYear() != me.postedDate.getFullYear()) {
                mes = {
                  title: `Ngày ${txtPosted} không hợp lệ`,
                  content: `Ngày ${txtPosted} phải nằm trong khoảng thời gian từ ngày <span class="color-green"> 1/1/${me.postedDate.getFullYear()}</span>
              đến <span class="color-green">31/12/${me.postedDate.getFullYear()}</span>. Vui lòng kiểm tra lại.`,
                };
                return mes;
              }
            }
          }
        }
      }

      // Kiểm tra từng grid và check từng dòng theo số tài khoản.
      // dòng nào chi tiết theo cái gì thì thông báo ra, thông báo trên 1 dòng và trên 1 grid
      const detailKeys = Object.keys(me._gridDetails);
      if (detailKeys.length > 0) {
        // validate grid Hạch toán
        let key = detailKeys.find(x => me._gridDetails[x] == me.refDetail);
        if (key) {
          let detail =
            me.model[key]?.filter(
              x => x.state != me.$ms.constant.ModelState.Empty && x.state != me.$ms.constant.ModelState.Delete,
            ) || [];

          // Type: 1: Định khoản ko hợp lệ, 2: Chưa nhập dòng chi tiết
          if (detail.length == 0 && !this.getVouchersForParallel().find(x => x === this.refType)) {
            mes = {
              title: me.$tm('i18nBaseForm.Message.FailSave'),
              content: me.$tm('i18nBaseForm.Message.ValidateNotTyping'),
            };
            //custom lại content của cảnh báo cất không thành công
            mes = me.customErrorMessage(mes);
            //Check tổng tiền vượt quá 15 ký tự sẽ show cảnh báo
            //TVDAT 02/08/2022l;
          } else if (me.model.total_amount > me.$ms.constant.RangeOfNumber.TotalMax) {
            mes = {
              title: me.$tm('i18nBaseForm.Message.FailSave'),
              content: 'Tổng số tiền của chứng từ vượt quá giới hạn 18 ký tự.',
            };
            return mes;
          } else if (!this.getVoucherNotCheckBusiness().find(x => x === this.refType)) {
            // không thuộc reftype trong getVoucherNotCheckBusiness thì mới kiểm tra định khoản
            // lấy dữ liệu của các grid
            let data = me.getSummaryDataGrid(me.refDetail, me.refDetailParallel, me.refDetailOther);

            data = data.filter(
              x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
            );

            data = data.filter(
              x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
            );

            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let objMes = {
                title: me.$tm('i18nBaseForm.Message.FailSave'),
                content: `Định khoản không hợp lệ. Xin vui lòng kiểm tra lại.`,
              };

              //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
              if (
                item.hasOwnProperty(me.$ms.constant.ColumnCommon.debitAccount) ||
                item.hasOwnProperty(me.$ms.constant.ColumnCommon.creditAccount)
              ) {
                if (item.debit_account && item.credit_account) {
                  if (item.debit_account.startsWith('0') || item.credit_account.startsWith('0')) {
                    return objMes;
                  }
                } else {
                  if (
                    (!item.debit_account && item.credit_account && !item.credit_account.startsWith('0')) ||
                    (item.debit_account && !item.credit_account && !item.debit_account.startsWith('0')) ||
                    (!item.debit_account && !item.credit_account)
                  ) {
                    return objMes;
                  }
                }
              } else {
                return {};
              }
            }
          }
        }
      }
      return mes;
    },

    /**
     * Lấy message
     * NMDUC1 16.12.2022
     */
    customErrorMessage(mes) {
      return mes;
    },

    /**
     * Validate grid hạch toán
     * NXCHIEN 27.06.2022
     */
    async validateAccounting() {
      let me = this;
      // Xử lý build message
      let invalid = (await me.validateDetail()) || [];
      me.cacheInvalidPosted = [...invalid];
      if (invalid.length) {
        var mes =
          'Bạn cần nhập các thông tin </br>' +
          invalid
            .map(o => {
              return `- <span class="color-green">${o.build.join(
                '; ',
              )}</span> cho các dòng hạch toán tài khoản <span class="color-green">${o.key}</span></br>`;
            })
            .join(' ') +
          `Nếu bạn không thấy <span class="color-green">` +
          me.$ms.commonFn.distinct(invalid.reduce((obj, x) => [...obj, ...x.build], [])).join('; ') +
          `</span> trên giao diện chứng từ, vui lòng xem hướng dẫn <a target="_blank" href=${this.$tm(
            'i18nHelpLink.ErrorPosted',
          )} class='text-link customCallBack' >tại đây</a>.`;
        me.invalidPost = invalid;
        me.resetValidateGrid();
      }
      return mes;
    },

    /**
     * Hàm reset style lỗi của các cell trên grid
     * NHANH3 18.05.2023
     */
    resetValidateGrid() {
      var me = this;

      for (const key in me._gridDetails) {
        // Lấy ra từng grid detail trên màn hình
        const element = me._gridDetails[key];

        if (!me.$refs[element] || !me.$refs[element].datax) {
          continue;
        }

        // Lấy ra danh sách dữ liệu trên grid có state khác rỗng
        var listData = [];
        listData = me.getDataValidateDictionary(element);

        // Lấy danh sách các cột trong grid
        let listColumn = me.$refs[element].columnFull;

        // Duyệt từng cột của mỗi dòng data
        for (let column of listColumn) {
          for (let item of listData) {
            // Nếu cột được hiển thị trên giao diện
            if (column.visible) {
              // Lấy ra row bằng refs theo detail_id
              var row = this.$refs[element].$refs[`trEditor_${item.ref_detail_id}`];
              if (!row || row.length == 0) {
                continue;
              }
              // Gán text error của từng cell bằng rỗng để bỏ style error nếu nó
              row[0].$refs[`cellEditor_${column.dataField}`][0].errorMessage = ``;
            }
          }
        }
      }
    },

    /**
     * Hàm set thông tin bắt buộc nhập khi thực hiện ghi sổ
     * NHANH3 17.05.2023
     */
    setErrorPost(invalid) {
      var me = this;
      if (!invalid || invalid.length == 0) {
        return;
      }

      var mapFieldMaster = new Set();
      var mapFieldDetail = [];
      me.resetInfoError();
      // Lấy ra các trường thông tin master bắt buộc nhập khi ghi sổ
      invalid.forEach(element => {
        element.mapField.forEach(field => {
          if (field.isCheckAll == true) {
            mapFieldMaster.add(field.mapField);
            mapFieldDetail.push({field: field.mapField, account: element.key});
          } else {
            mapFieldDetail.push({field: field.mapField, account: element.key});
          }
        });
      });
      mapFieldMaster = Array.from(mapFieldMaster);
      mapFieldDetail = Array.from(mapFieldDetail);
      me.invalidDetailPosted = mapFieldDetail;

      me.setRequiredPostMaster(mapFieldMaster);

      me.setRequiredPostDetail(mapFieldDetail);

      me.setFocusAfterValidate();
    },

    /**
     * Hàm set thông tin Số tiền đã chi quá số dự toán được giao khi thực hiện ghi sổ
     * dqdat1 15.01.2024
     */
    setErrorEstimatePost(dataError) {
      var me = this;
      if (!dataError || dataError.length == 0) {
        return;
      }

      let accountFilter = [
        me.$ms.constant.ColumnCommon.debitAccount,
        me.$ms.constant.ColumnCommon.creditAccount,
        me.$ms.constant.ColumnCommon.taxAccount,
        me.$ms.constant.ColumnCommon.cogsAccount,
        me.$ms.constant.ColumnCommon.inventoryAccount,
      ];

      // Check detail
      for (const key in me._gridDetails) {
        // Lấy ra từng grid detail trên màn hình
        const element = me._gridDetails[key];

        if (!me.$refs[element] || !me.$refs[element].datax) {
          continue;
        }

        // Lấy ra danh sách dữ liệu trên grid có state khác rỗng
        var listData = [];
        listData = me.getDataValidateDictionary(element);

        // Lấy danh sách các cột trong grid
        let listColumn = me.$refs[element].columnFull;
        let column = listColumn.find(x => x.dataField == 'amount_oc');

        if (column?.visible) {
          for (let item of listData) {
            for (let account of accountFilter) {
              if (!item[account]) {
                continue;
              }
              var mapField = dataError.find(
                x =>
                  x.budget_source_id == item.budget_source_id &&
                  x.budget_chapter_code == item.budget_chapter_code &&
                  x.budget_sub_kind_item_code == item.budget_sub_kind_item_code &&
                  (me.dbOptions.BudgetPlanReceiptMode != 1 || x.budget_item_code == item.budget_item_code) &&
                  (!me.dbOptions.UseTask || x.task_id == item.task_id) &&
                  (!me.dbOptions.UseProjectManagement || x.project_code == item.project_code) &&
                  x.account_number == item[account],
              );

              // Nếu cột được hiển thị trên giao diện
              if (item['amount_oc'] && mapField) {
                // Lấy ra row bằng refs theo detail_id
                var row = this.$refs[element].$refs[`trEditor_${item.ref_detail_id}`];
                if (!row || row.length == 0) {
                  continue;
                }
                // Gán thông tin lỗi cho cell
                row[0].$refs[`cellEditor_${column.dataField}`][0].displayError = true;
                row[0].$refs[`cellEditor_${column.dataField}`][0].errorMessage = `Đã chi quá số dự toán được giao`;
              }
            }
          }
        }
      }
    },

    /**
     * Hàm focus input lỗi đầu tiên sau khi
     * NHANH3 18.05.2023
     */
    setFocusAfterValidate() {
      var me = this;

      // Nếu thông tin master lỗi thì sẽ focus vào component đầu tiên
      if (me.isMasterError === true) {
        nextTick(() => {
          me.focusFirstError();
        });
      } else {
        if (
          (me.infoElementError.colIndex || me.infoElementError.colIndex == 0) &&
          (me.infoElementError.rowIndex || me.infoElementError.rowIndex == 0) &&
          me.infoElementError.col &&
          me.infoElementError.gridName
        ) {
          // Set focus vào cell đầu tiên của grid
          setTimeout(() => {
            me.$refs[me.infoElementError.gridName].changeEditor(
              me.infoElementError.colIndex,
              me.infoElementError.rowIndex,
              me.infoElementError.col,
            );
          }, 0);
          // Set style lỗi cho cell
          setTimeout(() => {
            if (me.firstElementError && me.firstElementError.$refs && me.firstElementError.$refs.msCombobox) {
              me.firstElementError.$refs.msCombobox.errorCell = true;
              me.firstElementError.$refs.msCombobox.errorMessage = 'error';
            }
          }, 10);
        }
      }
    },

    /**
     * Hàm set các trường hợp cần nhập trên master khi ghi sổ
     * NHANH3 18.05.2023
     */
    setRequiredPostMaster(mapFieldMaster) {
      // Lấy ra các combobox trên giao diện để check
      var comboboxs = this.getAllComboboxMaster();

      // Duyệt từng combobox
      for (let combobox of comboboxs) {
        if (combobox.mapField && mapFieldMaster.find(item => item == combobox.mapField) && !combobox.modelValue) {
          // Set message error cho combobox
          combobox.errorMessage = `${combobox.getTitleError()} không được để trống`;
          this.isMasterError = true;
        } else {
          combobox.errorMessage = ``;
        }
      }
    },

    /**
     * Hàm set các trường cần nhập trên grid detail khi ghi sổ
     * NHANH3 18.05.2023
     */
    setRequiredPostDetail(mapFieldDetail) {
      const me = this;

      if (mapFieldDetail == null || mapFieldDetail.length == 0) {
        return;
      }

      let accountFilter = [
        me.$ms.constant.ColumnCommon.debitAccount,
        me.$ms.constant.ColumnCommon.creditAccount,
        me.$ms.constant.ColumnCommon.taxAccount,
        me.$ms.constant.ColumnCommon.cogsAccount,
        me.$ms.constant.ColumnCommon.inventoryAccount,
      ];

      // Check detail
      for (const key in me._gridDetails) {
        // Lấy ra từng grid detail trên màn hình
        const element = me._gridDetails[key];

        if (!me.$refs[element] || !me.$refs[element].datax) {
          continue;
        }

        // Lấy ra danh sách dữ liệu trên grid có state khác rỗng
        var listData = [];
        listData = me.getDataValidateDictionary(element);

        // Lấy danh sách các cột trong grid
        let listColumn = me.$refs[element].columnFull;

        // Duyệt từng cột của mỗi dòng data
        for (let column of listColumn) {
          for (let item of listData) {
            for (let account of accountFilter) {
              if (!item[account]) {
                continue;
              }

              var mapField = mapFieldDetail.find(x => x.field == column.dataField && x.account == item[account]);

              if (!mapField || (item.is_service && mapField.field == 'stock_code')) {
                continue;
              }

              // Nếu cột được hiển thị trên giao diện
              if (!item[mapField.field] && column.visible) {
                // Lấy ra row bằng refs theo detail_id
                var row = this.$refs[element].$refs[`trEditor_${item.ref_detail_id}`];
                if (!row || row.length == 0) {
                  continue;
                }
                // Gán thông tin lỗi cho cell
                row[0].$refs[`cellEditor_${column.dataField}`][0].displayError = true;
                row[0].$refs[`cellEditor_${column.dataField}`][0].errorMessage = `Không được để trống`;

                // Set element lỗi đầu tiên
                if (!this.firstElementError) {
                  this.firstElementError = row[0].$refs[`cellEditor_${column.dataField}`][0];
                }

                // Lấy ra thông tin vị trí của element lỗi đầu tiên trên grid
                if (
                  !this.infoElementError.colIndex &&
                  !this.infoElementError.rowIndex &&
                  !this.infoElementError.col &&
                  !this.infoElementError.gridName
                ) {
                  this.infoElementError = {
                    colIndex: row[0].$refs[`cellEditor_${column.dataField}`][0].colIndex,
                    rowIndex: row[0].$refs[`cellEditor_${column.dataField}`][0].rowIndex,
                    col: column,
                    gridName: element,
                  };
                }
              }
            }
          }
        }
      }
    },

    /**
     * Validate số tiền
     * NXCHIEN 27.06.2022
     */
    validateAmount(detail, keyValue) {
      const me = this;
      let mes = [];
      detail.forEach(item => {
        let key = me._gridDetails[keyValue];
        if (
          key &&
          me.$refs[key] &&
          me.$refs[key].columnx &&
          me.$refs[key].columnx.find(
            x =>
              x.dataField == me.$ms.constant.ColumnCommon.amountOc ||
              x.dataField == me.$ms.constant.ColumnCommon.amount,
          )
        ) {
        }
        if (!item[me.$ms.constant.ColumnCommon.amountOc] && !item[me.$ms.constant.ColumnCommon.amount]) {
          mes = {
            content: 'Giá trị hạch toán phải khác 0.',
            type: 3,
            title: 'Ghi sổ không thành công',
          };
          return mes;
        }
      });
      return mes;
    },

    /**
     * Thực hiện validate sinh hạch toán đồng thời khi cất theo các option thiết lập hạch toán đồng thời
     * Key DBOption: AutoGenerateParallel trong đó: 0-Tự động sinh đồng thời khi cất chứng từ | 1-Không tự động sinh đồng thời khi cất chứng từ | 2-Hỏi sinh đồng thời khi cất chứng từ
     * @param {*} mode
     * NVTUAN1 01.08.2022
     * nthien4 23.09.2022/ Bổ sung rule tự động sinh bút toán hạch toán đồng thời cho chứng từ hạch toán ngoại tệ
     */
    async validateGenerateParallel(mode) {
      var me = this;
      //Gọi hàm kiểm tra grid hạch toán đồng thời đã có dữ liệu chưa
      let isEmpty = await me.checkEmptyGridParallel();
      //TH1: Grid hạch toán đồng thời chưa có dữ liệu
      if (isEmpty) {
        // Không tự động sinh đồng thời khi cất chứng từ hoặc chưa thiết lập gì
        if (
          me.dbOptions.AutoGenerateParallel == 1 ||
          me.dbOptions.AutoGenerateParallel === null ||
          me.dbOptions.AutoGenerateParallel === undefined
        ) {
          await me.validatePostedAndSave(mode);
        }
        // Tự động sinh đồng thời khi cất chứng từ
        else if (me.dbOptions.AutoGenerateParallel == 0) {
          me.loading = false;
          await me.generateParallel(true, true);
          await me.validatePostedAndSave(mode);
        }
        // Hỏi sinh đồng thời khi cất chứng từ
        else if (me.dbOptions.AutoGenerateParallel == 2) {
          // Kiểm tra xem bản ghi hiện tại có sinh được hạch toán đồng thời không
          let result = await me.getParallelRulesDetail(true, true);
          // Kiểm tra bản ghi hiện tại có sinh được tài khoản 007 không
          let resultCheck007 = me.checkGenDataParallel007();

          // Nếu không sinh được thì cất như thường
          if (!result && !resultCheck007) {
            await me.validatePostedAndSave(mode);
            return true;
          }
          me.loading = false;
          // Nếu có sinh được mới show cảnh báo
          showConfirmAutoGenerateParallel(
            'Bạn có muốn chứng từ tự động hạch toán đồng thời không?',
            'Chứng từ chưa được hạch toán đồng thời',
            undefined,
            500,
            'Áp dụng sinh hạch toán đồng thời cho lần sau',
          ).then(async answer => {
            // Click Có hoặc Không
            if (answer) {
              let param = {};
              switch (answer.answer) {
                case true:
                  me.loading = false;
                  await me.generateParallel(true, true);
                  await me.validatePostedAndSave(mode);
                  if (!answer.IsShowMessage) {
                    //Cập nhật luôn vào store
                    me.dbOptions.AutoGenerateParallel = 0;
                    //Thêm vào object để cất riêng
                    param.AutoGenerateParallel = 0;
                  }

                  break;
                case false:
                  await me.validatePostedAndSave(mode);
                  if (!answer.IsShowMessage) {
                    //Cập nhật luôn vào store
                    me.dbOptions.AutoGenerateParallel = 1;
                    //Thêm vào object để cất riêng
                    param.AutoGenerateParallel = 1;
                  }
                  break;
                default:
              }
              //Cập nhật lại option thiết lập hạch toán đồng thời nếu tick vào "Áp dụng sinh hạch toán đồng thời cho lần sau"
              if (!answer.IsShowMessage) {
                await me.$store.dispatch('dbOption/updateDbOptions', param);
              }
            }
          });
        }
      }
      //TH2: Grid hạch toán đồng thời đã có dữ liệu
      else {
        //Luôn sinh hạch toán đồng thời trước khi cất không quan tâm AutoGenerateParallel đang có giá trị là gì
        me.loading = false;
        await me.generateParallel(false, true);
        await me.validatePostedAndSave(mode);
      }
    },

    /**
     * Hàm validate các thông tin cần nhập theo chi tiết tài khoản để cất và ghi sổ
     * NHANH3 31.07.2023
     */
    async validatePostedAndSave(mode) {
      var me = this;
      // Check các trường thông tin bắt buộc nhập theo tài khoản NHANH3 28.05.2023
      let message = await me.validatePosted();
      if (message && message.content && message.type == 1) {
        me.loading = false;
        showError(message.content, me.$tm('i18nBaseForm.Message.FailSave')).then(() => {
          me.setErrorPost(me.invalidPost);
        });
        return;
      }
      me.super('save', baseDetailPopup, mode);
    },

    /**
     * Check điều kiện để gen được dữ liệu 007 tại hạch toán đồng thời
     * Created by: nthien4 30.09.2022,
     */
    checkGenDataParallel007() {
      let me = this;
      if (
        me.dbOptions.GenerateParallel007 &&
        me.model.currency_code != me.$t('i18nEnum.Currency.VND') &&
        me.gridDetail.data.find(
          h =>
            h.state !== me.$ms.constant.ModelState.Empty &&
            h.state !== me.$ms.constant.ModelState.Delete &&
            (h.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
              h.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency) ||
              h.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
              h.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency)),
        ) != null
      ) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * Sinh hạch toán đồng thời
     * @param {*} autoGenerate Có tự động sinh hạch toán đồng thời hay không? true => bỏ qua cảnh báo, luôn luôn sinh lại hạch toán đồng thời
     * @param {*} isSave Là sự kiện click Cất
     * @returns Nếu không có cảnh báo thì trả về null đồng thời tự sinh hạch toán đồng thời,
     * nếu có cảnh báo thì tự sinh hạch toán đồng thời sau đó sẽ trả về promise
     * HTHIEP 11.07.2022
     * Modified by NVTUAN1: Bổ sung thêm cảnh báo khi không có rules hoặc dữ liệu không phù hợp với quy tắc thiết lập
     * nthien4 23.09.2022: Bổ sung rule sinh hạch toán cho ngoại tệ
     */
    async generateParallel(autoGenerate, isSave) {
      const me = this;
      //gridDetail => cấu hình đúng là grid của hạch toán
      //gridDetailParallel => Cấu hình đúng là grid của hạch toán đồng thời
      if (!me.gridDetail || !me.gridDetailParallel) {
        return null;
      }
      try {
        // Tự động sinh bút toán hạch toán đồng thời cho chứng từ hạch toán ngoại tệ
        // Nếu dbOption tích chọn Sinh chứng từ ghi sổ đồng thời tài khoản 007 => check đến tài khoản hạch toán để sinh hạch toán đồng thời
        //Danh sách hạch toán đồng thời
        let parallelDatas = [];

        let checkGenerateParallel007 = false;
        let parallelDatas007 = await me.generateParallelWith007();

        if (parallelDatas007.length > 0) {
          checkGenerateParallel007 = true;
          parallelDatas = _.cloneDeep(parallelDatas007);
        }

        if (!me.gridDetailParallel.getColumns() && !checkGenerateParallel007) {
          return await me.validateParallelWhenDataNotValid(autoGenerate, isSave);
        }

        //Lấy ra module thực thi theo refType hiện tại
        let moduleVoucherParallelDetail = ModuleAccountParallelRuleDetail;
        if (me.getVouchersForParallel().find(x => x === me.refType)) {
          moduleVoucherParallelDetail = ModuleSysAccountParallelVoucherListRuleDetail;
        }

        const ruleDetailForeignKey = me.$store.state[moduleVoucherParallelDetail]._config.field.foreignKey;

        if (!ruleDetailForeignKey && !checkGenerateParallel007) {
          return await me.validateParallelWhenDataNotValid(autoGenerate, isSave);
        }

        //Trường thông tin dùng để cộng âm dương
        const ruleDetailSign = me.$store.state[moduleVoucherParallelDetail]._config.field.sign;

        //Lấy ra đối tượng trả về bao gồm đối tượng các dòng hạch toán sau khi thêm thuộc tính rule thỏa mãn và đối tượng các bản và các bản ghi chi tiết hạch toán đồng thời
        const objParallel = await me.getParallelRulesDetail(autoGenerate, isSave);

        //Không có object objParallel return null
        if (!(objParallel && objParallel.gridDetailData && objParallel.parallelRulesDetail)) {
          if (parallelDatas.length == 0) {
            return null;
          }
        } else {
          //Dữ liệu các dòng hạch toán
          const gridDetailData = objParallel.gridDetailData;

          //Các bản ghi chi tiết hạch toán đồng thời trên db
          const parallelRulesDetail = objParallel.parallelRulesDetail;

          //Lấy ra dòng có sinh hạch toán đồng thời trên detail => tiến hành sinh hạch toán đồng thời theo rule
          gridDetailData
            .filter(x => x.rule)
            .forEach(item => {
              //Lấy ra chi tiết hạch toán đồng thời theo rule
              let detailRules = parallelRulesDetail.filter(
                x => item.rule[ruleDetailForeignKey] === x[ruleDetailForeignKey],
              );
              if (detailRules && detailRules.length > 0) {
                //Sinh hạch toán đồng thời
                detailRules.filter(detailRule => {
                  let parallelData = {};
                  //Sinh model hạch toán đồng thời
                  me.getParallelModel().forEach(column => {
                    if (column) {
                      //Check field tiền, hiện trường này đang fix cứng
                      if (
                        column.dataField === me.$ms.constant.ColumnCommon.amountOc ||
                        column.dataField === me.$ms.constant.ColumnCommon.amount
                      ) {
                        if (item[column.dataField] || item[column.mapField]) {
                          parallelData[column.dataField] =
                            item[column.mapField || column.dataField] * (detailRule[ruleDetailSign] || 1);
                        }
                      } else {
                        //Lấy tài khoản nợ có ở dòng chi tiết hạch toán đồng thời
                        if (
                          column.dataField == me.$ms.constant.ColumnCommon.debitAccount ||
                          column.dataField == me.$ms.constant.ColumnCommon.creditAccount
                        ) {
                          parallelData[column.dataField] = detailRule[column.dataField];
                        }
                        //Lấy thông tin ghi chú (ghi âm - ghi dương) để check rule các bản ghi nhân bản và các bản ghi người dùng tự nhập
                        else if (column.dataField == me.$ms.constant.ColumnCommon.sign) {
                          parallelData[column.dataField] = detailRule[column.dataField];
                        }
                        //Các trường không có dữ liệu thì không cần map
                        else {
                          if (item[column.dataField] !== null && item[column.dataField] !== undefined) {
                            parallelData[column.dataField] = item[column.dataField];
                          }
                        }
                      }
                    }
                  });
                  parallelData[me.$ms.constant.ColumnCommon.orgRefDetailId] =
                    item[me.$ms.constant.ColumnCommon.refDetailId];
                  parallelDatas.push(parallelData);
                });
              }
            });
        }

        //Có cờ tự gen => tự động gen hạch toán đồng thời bất chấp option
        if (autoGenerate) {
          //Set dữ liệu vào model hạch toán đồng thời
          return me.setParallelData(parallelDatas);
        } else {
          //Nếu không tự sinh thì check valid để cảnh báo
          /**
           * Mảng lưu thông tin item không thể xác định đc sinh ra từ đâu
           * => đoạn này thường do khách hàng tự nhập hạch toán đồng thời
           */
          let noneItems = [];

          /**
           * Mảng lưu thông tin hạch toán không sinh theo rule
           */
          let notValidItems = [];

          //Update thông tin ref cho dòng đang hạch toán
          const updateRef = item => {
            let itemForRule = me.getItemMapForParallelRule(parallelDatas, item);
            if (itemForRule) {
              item[me.$ms.constant.ColumnCommon.orgRefDetailId] =
                itemForRule[me.$ms.constant.ColumnCommon.orgRefDetailId];
            }
          };

          // Lấy thông tin hạch toán đang có trên grid hạch toán đồng thời hiện tại
          const gridDetailParallelData = await me.getDataGridDetailParallel();

          // Tiến hành đi map và valid từng dòng 1
          gridDetailParallelData.forEach(item => {
            if (item[me.$ms.constant.ColumnCommon.orgRefDetailId]) {
              //Kiểm tra xem dòng hạch toán đồng thời hiện tại có map với dòng sinh ra theo rule không?
              if (!me.hasItemMapParallelForRule(parallelDatas, item)) {
                notValidItems.push(item);
              }
            } else {
              updateRef(item);
              // Trường hợp người dùng tự thêm => push vào mảng
              noneItems.push(item);
            }
          });
          if (notValidItems.length === 0) {
            //Map những item thêm tay vào detail
            noneItems.filter(item => {
              if (item[me.$ms.constant.ColumnCommon.orgRefDetailId]) {
                //Kiểm tra xem dòng hạch toán đồng thời hiện tại có map với dòng sinh ra theo rule không?
                if (!me.hasItemMapParallelForRule(parallelDatas, item)) {
                  notValidItems.push(item);
                }
              } else {
                notValidItems.push(item);
              }
            });
          }

          //Có bản ghi không hợp lệ hoặc không có bản ghi không hợp lệ và các bản ghi trên grid hạch toán đồng thời khác với các bản ghi hạch toán đồng thời được sinh ra => Show cảnh báo
          if (
            notValidItems.length > 0 ||
            (notValidItems.length === 0 &&
              gridDetailParallelData.length !== parallelDatas.length &&
              !checkGenerateParallel007)
          ) {
            return me.showConfirmUpdateParallel(parallelDatas, gridDetailParallelData, noneItems);
          }
        }
      } finally {
        //unmask
        me.gridDetailParallel.unMask();
      }
    },

    /**
     * Gen dữ liệu hạch toán cho 007 nếu thỏa mãn
     * nthien4 30.09.2022
     */
    async generateParallelWith007() {
      let me = this;
      let parallelDatas = [];
      if (
        me.dbOptions.GenerateParallel007 &&
        me.model.currency_code != me.$t('i18nEnum.Currency.VND') &&
        me.gridDetail.data &&
        me.gridDetail.data.length > 0
      ) {
        let cogsAccounts = [];
        if (this.offlineReady) {
          const dataAccountCache = await store.getters[`${ModuleAccountCombo}/items`];
          if (dataAccountCache) {
            const filters = [
              {
                Field: 'account_number',
                Operator: '*.',
                Value: me.$ms.constant.AccountNumber.Account007,
              },
            ];
            cogsAccounts = me.$ms.commonFn.filterArray(dataAccountCache, filters);
          }
        } else {
          cogsAccounts = await accountAPI.getListChildAccount(me.$ms.constant.AccountNumber.Account007);
        }
        let accountChild007 = '';
        if (cogsAccounts && cogsAccounts.length > 0) {
          accountChild007 = cogsAccounts.find(x => x.is_parent != true)?.account_number;
        }
        me.gridDetail.data
          .filter(
            h =>
              h.state !== me.$ms.constant.ModelState.Empty &&
              h.state !== me.$ms.constant.ModelState.Delete &&
              (h.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
                h.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency) ||
                h.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
                h.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency)),
          )
          .forEach(n => {
            if (
              n.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
              n.credit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency)
            ) {
              let parallelCreditClone = _.cloneDeep(n);
              parallelCreditClone[me.$ms.constant.ColumnCommon.orgRefDetailId] =
                n[me.$ms.constant.ColumnCommon.refDetailId];
              parallelCreditClone[me.$ms.constant.ColumnCommon.refDetailId] = null;
              parallelCreditClone[me.$ms.constant.ColumnCommon.debitAccount] = null;
              parallelCreditClone[me.$ms.constant.ColumnCommon.creditAccount] = accountChild007;
              parallelDatas.push(parallelCreditClone);
            }
            if (
              n.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency2) ||
              n.debit_account?.startsWith(me.$ms.constant.AccountNumber.ForeignCurrency)
            ) {
              let parallelDebitClone = _.cloneDeep(n);

              parallelDebitClone[me.$ms.constant.ColumnCommon.orgRefDetailId] =
                n[me.$ms.constant.ColumnCommon.refDetailId];
              parallelDebitClone[me.$ms.constant.ColumnCommon.refDetailId] = null;
              parallelDebitClone[me.$ms.constant.ColumnCommon.creditAccount] = null;
              parallelDebitClone[me.$ms.constant.ColumnCommon.debitAccount] = accountChild007;
              parallelDatas.push(parallelDebitClone);
            }
          });
      }
      return parallelDatas;
    },

    /**
     * Thực hiện lấy ra dữ liệu các bản ghi hạch toán đồng thời trong db
     * @param {*} autoGenerate
     * @param {*} isSave
     * @returns
     * NVTUAN1 04.08.2022
     */
    async getParallelRulesDetail(autoGenerate, isSave) {
      const me = this;
      const rules = await me.getAccountParallelRule();
      let isGenParalell007 = me.checkGenDataParallel007();
      if ((rules == null || rules.length === 0) && !isGenParalell007) {
        return await me.validateParallelWhenDataNotValid(autoGenerate, isSave);
      }

      //Lấy ra module thực thi theo refType hiện tại
      let moduleVoucherParallelDetail = ModuleAccountParallelRuleDetail;
      if (me.getVouchersForParallel().find(x => x === me.refType)) {
        moduleVoucherParallelDetail = ModuleSysAccountParallelVoucherListRuleDetail;
      }

      const ruleDetailForeignKey = me.$store.state[moduleVoucherParallelDetail]._config.field.foreignKey;

      const gridDetailData = await me.getDataGridDetail();

      //Lấy danh sách nguồn để map vào từng row lấy thông tin group_property_type
      const budgetSources = await me.getBudgetSource();
      const ruleIdDetails = [];

      //Lấy từng dòng ra thực hiện tìm rule hạch toán tương ứng
      gridDetailData.forEach(item => {
        //Tìm ra rule khớp với dòng detail
        let rule = me.getRuleValid(rules, item, {budgetSources});
        //Nếu rule khớp thì push rule vào mảng
        if (rule) {
          item.rule = rule;
          if (!ruleIdDetails.find(x => x === rule[ruleDetailForeignKey])) {
            ruleIdDetails.push(rule[ruleDetailForeignKey]);
          }
        }
      });

      if ((!ruleIdDetails || ruleIdDetails.length === 0) && !isGenParalell007) {
        return await me.validateParallelWhenDataNotValid(autoGenerate, isSave);
      }
      let parallelRulesDetail = [];
      if (me.offlineReady) {
        const dataRulesDetails = await store.getters[`${moduleVoucherParallelDetail}/items`];
        if (dataRulesDetails && Array.isArray(dataRulesDetails) && dataRulesDetails.length > 0) {
          parallelRulesDetail = dataRulesDetails.filter(x => ruleIdDetails.includes(x[ruleDetailForeignKey]));
        }
      } else {
        parallelRulesDetail = await me.$store.dispatch(`${moduleVoucherParallelDetail}/getDataById`, {
          id: ruleIdDetails.join(';'),
        });
      }

      if ((!parallelRulesDetail || parallelRulesDetail.length === 0) && !isGenParalell007) {
        return await me.validateParallelWhenDataNotValid(autoGenerate, isSave);
      }

      return {
        parallelRulesDetail: parallelRulesDetail,
        gridDetailData: gridDetailData,
      };
    },

    /**
     * Lấy các dòng dữ liệu trên grid Hạch toán
     * NVTUAN1 04.08.2022
     */
    async getDataGridDetail() {
      const me = this;
      //Submit grid trước khi lấy data
      await me.gridDetail.submitEditor();

      //Lấy dữ liệu tại detail để check khớp rule hạch toán đồng thời không?
      // NVTUAN1 28.07.2022: Chỉ lấy các dòng dữ liệu khác Empty và Delete để hạch toán đồng thời
      let gridDetailData = _.cloneDeep(
        me.gridDetail
          .getData()
          .filter(x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete),
      );

      // NXCHIEN 31.07.2022: Lọc bớt dữ liệu TH là bảng kê đã và chưa cấp dự toán.
      if (me.getVouchersForParallel().find(x => x === me.refType)) {
        // Chỉ lấy ra các bản ghi thanh toán
        gridDetailData = me.getDataVoucherList(gridDetailData);
      }

      return gridDetailData;
    },

    /**
     * Lấy các dòng dữ liệu trên grid Hạch toán đồng thời
     * NVTUAN1 04.08.2022
     */
    async getDataGridDetailParallel() {
      const me = this;
      //Submit grid trước khi lấy data
      await me.gridDetailParallel.submitEditor();

      //Lấy dữ liệu tại detail để check khớp rule hạch toán đồng thời không?
      // NVTUAN1 28.07.2022: Chỉ lấy các dòng dữ liệu khác Empty và Delete để hạch toán đồng thời
      let gridDetailParallelData = _.cloneDeep(
        me.model.Parallels.filter(
          x => x && x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
        ),
      );

      return gridDetailParallelData;
    },

    /**
     * Validate nghiệp vụ Sinh hạch toán đồng thời khi dữ liệu không hợp lệ
     * @param {*} autoGenerate Có tự động sinh hạch toán đồng thời hay không? true => bỏ qua cảnh báo, luôn luôn sinh lại hạch toán đồng thời
     * @param {*} isSave Là sự kiện click Cập nhật hạch toán đồng thời
     * @returns
     * NVTUAN1 02.08.2022
     * ttanh1 13.09.2023 - Thêm dữ liệu để xuất khẩu với TH không có rule hạch toán nào thỏa mãn
     */
    async validateParallelWhenDataNotValid(autoGenerate, isSave) {
      const me = this;
      if (me.notAlertUpdateParallels) {
        return;
      }
      //Nếu là sự kiện Save
      if (isSave) {
        //Nếu cờ check là true thì tự động cập nhật ngược lại thì show thông báo
        if (autoGenerate) {
          return me.setParallelData([]);
        } else {
          //Nếu không tự sinh thì check valid để cảnh báo
          /**
           * Mảng lưu thông tin item không thể xác định đc sinh ra từ đâu
           * => đoạn này thường do khách hàng tự nhập hạch toán đồng thời
           */
          let noneItems = [];

          /**
           * Mảng lưu thông tin hạch toán không sinh theo rule
           */
          let notValidItems = [];

          // Lấy thông tin hạch toán đang có trên grid hạch toán đồng thời hiện tại
          const gridDetailParallelData = await me.getDataGridDetailParallel();
          // Tiến hành đi map và valid từng dòng 1
          gridDetailParallelData.forEach(item => {
            if (item[me.$ms.constant.ColumnCommon.orgRefDetailId]) {
              notValidItems.push(item);
            } else {
              // Trường hợp người dùng tự thêm => push vào mảng
              noneItems.push(item);
            }
          });
          if (notValidItems.length === 0) {
            //Map những item thêm tay vào detail
            notValidItems.push(...noneItems);
          }

          //Có bản ghi không hợp lệ hoặc không có bản ghi không hợp lệ và các bản ghi trên grid hạch toán đồng thời khác với các bản ghi hạch toán đồng thời được sinh ra => Show cảnh báo
          if (notValidItems.length > 0 || notValidItems.length === 0) {
            return me.showConfirmUpdateParallel([], gridDetailParallelData, noneItems);
          }
        }
      }
      //Nếu là sự kiện click Cập nhật hạch toán đồng thời thì show toast cảnh báo không tự động sinh được hạch toán đồng thời
      else {
        // nhhanh 22.06.2023 Nếu cờ check là true thì tự động cập nhật ngược lại
        if (autoGenerate) {
          me.setParallelData([]);
        }

        let mes = me.$tm('i18nBaseForm.Message.WarningParallelNotValidRule');
        return me.$toast.open({
          message: mes,
          type: 'warning',
          position: 'top',
          duration: 15000,
          dismissible: true,
          class: 'toast-warning-parallel',
          onClick: pointerEvent => {
            if (pointerEvent && pointerEvent.target && pointerEvent.target.id === 'accountParallelRule') {
              popupUtil.show('AccountParallelRule');
            }
          },
        });
      }
    },
    /**
     * Show confirm cập nhật hạch toán đồng thời khi hạch toán đồng thời không phù hợp với quy tắc thiết lập hạch toán đồng thời
     * @param {*} parallelDatas
     * @returns
     * NVTUAN1 02.08.2022
     */
    showConfirmUpdateParallel(parallelDatas, voucherDatas = [], noneItems = []) {
      let me = this;
      return new Promise((resolve, reject) => {
        try {
          showConfirmGenerateParallel(
            this.$tm('i18nBaseForm.Message.WarningParallelNotAutoGenerate'),
            'Cập nhật hạch toán đồng thời',
            500,
            () => {
              // tbngoc 28.11.2023: Tạm thời khi mất mạng không xuất khẩu được
              if (!me.offlineReady) {
                exportDifferenceParallel(parallelDatas, voucherDatas, noneItems);
              }
            },
          ).then(answer => {
            switch (answer) {
              case true:
                //Set dữ liệu vào model hạch toán đồng thời
                this.setParallelData(parallelDatas);
                break;
            }
            resolve(answer);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    /**
     * Thực hiện check xem grid Hạch toán đồng thời có dòng dữ liệu không
     * @returns false: có dòng dữ liệu | true: không có dòng dữ liệu
     * NVTUAN1 02.08.2022
     */
    async checkEmptyGridParallel() {
      const me = this;
      //Submit grid trước khi lấy data
      await me.gridDetailParallel.submitEditor();
      return (
        !me.model.Parallels ||
        !me.model.Parallels.find(
          x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
        ) ||
        me.model.Parallels.find(
          x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
        ).length === 0
      );
    },

    /**
     * Thực hiện show màn hình Thiết lập quy tắc hạch toán đồng thời
     * NVTUAN1 03.08.2022
     */
    // showAccountParallelRule() {
    //   const me = this;
    //   popupUtil.show('AccountParallelRule', {
    //     mode: me.$ms.constant.FormState.View
    //   });
    // },

    /**
     * lấy ra bản ghi hạch toán đồng thời hiện tại map đc với dòng được sinh ra từ chi tiết hạch toán? => dev cần override lại để check thêm rule
     * @param {*} parallels Danh sách hạch toán đồng thời sinh ra theo rule
     * @param {*} item item cần check
     * HTHIEP 12.07.2022
     */
    getItemMapForParallelRule(parallels, item) {
      const me = this;

      //Một số trường đang so sánh == để khi rơi vào trường hợp so sánh undefined với null vẫn đúng
      return parallels.find(
        x =>
          ((!x[me.$ms.constant.ColumnCommon.debitAccount] && !item[me.$ms.constant.ColumnCommon.debitAccount]) ||
            x[me.$ms.constant.ColumnCommon.debitAccount] === item[me.$ms.constant.ColumnCommon.debitAccount]) &&
          ((!x[me.$ms.constant.ColumnCommon.creditAccount] && !item[me.$ms.constant.ColumnCommon.creditAccount]) ||
            x[me.$ms.constant.ColumnCommon.creditAccount] === item[me.$ms.constant.ColumnCommon.creditAccount]) &&
          x[me.$ms.constant.ColumnCommon.budgetSourceId] &&
          item[me.$ms.constant.ColumnCommon.budgetSourceId] &&
          x[me.$ms.constant.ColumnCommon.budgetSourceId].toLowerCase() ===
            item[me.$ms.constant.ColumnCommon.budgetSourceId].toLowerCase() &&
          x[me.$ms.constant.ColumnCommon.cashWithdrawTypeId] ===
            item[me.$ms.constant.ColumnCommon.cashWithdrawTypeId] &&
          x[me.$ms.constant.ColumnCommon.methodDistributeType] ===
            item[me.$ms.constant.ColumnCommon.methodDistributeType] &&
          x[me.$ms.constant.ColumnCommon.amount] == item[me.$ms.constant.ColumnCommon.amount] &&
          x[me.$ms.constant.ColumnCommon.amountOc] == item[me.$ms.constant.ColumnCommon.amountOc],
      );
    },
    /**
     * Lấy ra rule có thể sinh hạch toán đồng thời theo item => nếu có thêm rule cấu hình thêm tại đây
     * @param {*} rules Rule sinh hạch toán đồng thời
     * @param {*} item item cần kiểm tra sinh hạch toán đồng thời
     * @param {object} options Cấu hình thêm option
     * HTHIEP 11.07.2022
     */
    getRuleValid(rules, item, options = {}) {
      const me = this;
      if (!options.budgetSources || options.budgetSources.length === 0) {
        return null;
      }

      if (!me.refType) {
        console.error('Thiếu cấu hình refType');
      }
      //lấy ra budgetSource hiện tại để kiểm tra tính chất nguồn
      let budgetSourceItem =
        options.budgetSources.find(
          x =>
            x.budget_source_id &&
            item.budget_source_id &&
            x.budget_source_id.toLowerCase() === item.budget_source_id.toLowerCase(),
        ) || {};

      //Nếu tính chất nguồn đang null thì gán về là tính chất nguồn không chọn
      if (!budgetSourceItem.group_property_type) {
        budgetSourceItem.group_property_type = 0;
      }

      if (me.getVouchersForParallel().find(x => x === me.refType)) {
        //Check reftype hiện tại, nếu là bảng kê trong list thì thực hiện hạch toán theo rule khác
        return me.getRulesWithVoucher(rules, item, budgetSourceItem);
      }
      return me.getRulesWithAccount(rules, item, options.budgetSources, budgetSourceItem);
    },

    /**
     * Lấy rule hạch toán theo bảng kê
     * @param {*} rules
     * @param {*} item
     * @param {*} budgetSourceItem
     */
    getRulesWithVoucher(rules, item, budgetSourceItem) {
      // Sắp xếp lại theo nghiệp vụ đặc thù để dòng hạch toán đồng thời TCTK lên trên do rule sinh nợ 6113x
      rules = rules.sortObject('particularity desc','sort_order');
      return rules.find(
        x =>
          (x.budget_source_group_property_type === null ||
            x.budget_source_group_property_type === undefined ||
            x.budget_source_group_property_type == budgetSourceItem.group_property_type) &&
          ((x.debit_account &&
            x.credit_account &&
            this.checkValidAccount(item.debit_account, x.debit_account) &&
            this.checkValidAccount(item.credit_account, x.credit_account)) ||
            (this.checkValidAccount(item.debit_account, x.debit_account) && !x.credit_account) ||
            (this.checkValidAccount(item.credit_account, x.credit_account) && !x.debit_account)),
      );
    },

    /**
     * Lấy rule hạch toán chứng từ
     * @param {*} rules
     * @param {*} item
     * @param {*} budgetSources
     * @param {*} budgetSourceItem
     * @returns
     * Modified by NVTUAN1 11.08.2022: Bổ sung thêm case tài khoản chọn "Tất cả"
     */
    getRulesWithAccount(rules, item, budgetSources, budgetSourceItem) {
      const me = this;
      //Fix nguồn tất cả => nếu dev đổi id nguồn tất cả thì đổi lại ở FixValue.js
      const allBudgetSourceId = me.$ms.constant.FixValue.AllBudgetSourceId;
      //Fix tài khoản tất cả => nếu dev đổi giá trị lưu tài khoản tất cả thì đổi lại ở FixValue.js
      const allAccount = me.$ms.constant.FixValue.AllText;
      return rules.find(
        x =>
          x.cash_withdraw_type_id === item.cash_withdraw_type_id &&
          x.method_distribute_type === item.method_distribute_type &&
          ((x.budget_source_id &&
            allBudgetSourceId &&
            x.budget_source_id.toLowerCase() === allBudgetSourceId.toLowerCase()) ||
            me.checkValidBudgetSource(budgetSources, item.budget_source_id, x.budget_source_id)) &&
          x.budget_source_group_property_type === budgetSourceItem.group_property_type &&
          ((x.debit_account && allAccount && x.debit_account.toLowerCase() === allAccount.toLowerCase()) ||
            me.checkValidAccount(item.debit_account, x.debit_account)) &&
          ((x.credit_account && allAccount && x.credit_account.toLowerCase() === allAccount.toLowerCase()) ||
            me.checkValidAccount(item.credit_account, x.credit_account)),
      );
    },

    /**
     * @private
     * Kiểm tra xem source hiện tại có nằm trong dist hay không?
     * @param {*} source budgetSource cần kiểm tra
     * @param {*} dist danh sách budgetSource dạng 53cac229-076c-4677-be9b-3b7f7c52df64;53cac229-076c-4677-be9b-3b7f7c52df64;,,,
     * HTHIEP 26.07.2022
     */
    checkValidBudgetSource(budgetSources, source, dist) {
      //check xem nguồn hiện tại nằm trong dist không, nằm trong thì return luôn
      if (source && dist && dist.split(';').find(x => x && x.trim().toLowerCase() === source.toLowerCase())) {
        return true;
      }
      //Th2: Lấy con chi tiết nhất để check thử
      if (source && dist && dist.split(';').find(x => x && this.hasChildBudget(budgetSources, source, x.trim()))) {
        return true;
      }
      return false;
    },

    /**
     * @private
     * Kiểm tra xem account source có phải là con của account dist hay không
     * @param {*} items
     * @param {*} source
     * @param {*} dist
     * @returns
     */
    hasChildBudget(items, source, dist) {
      const checkChild = (s, d) => {
        var budgetSource = items.find(x => x && s && x.budget_source_id.toLowerCase() === s.toLowerCase());
        if (!budgetSource) {
          return false;
        }
        //Nếu k có cha thì break và trả kết quả luôn
        if (
          !budgetSource.parent_id ||
          (budgetSource.budget_source_id &&
            budgetSource.parent_id &&
            budgetSource.budget_source_id.toLowerCase() === budgetSource.parent_id.toLowerCase())
        ) {
          return false;
        }
        //Check xem source có phải là con của dist k => đoạn này đệ quy để check đến khi k còn cha thì thôi
        if (budgetSource.parent_id && d && budgetSource.parent_id.toLowerCase() === d.toLowerCase()) {
          return true;
        }
        return checkChild(budgetSource.parent_id, d);
      };

      return checkChild(source, dist);
    },

    /**
     * @private
     * Kiểm tra xem tài khoản hiện tại có nằm trong dist hay không? kiểm tra cả con chi tiết nhất
     * @param {*} source tài khoản cần kiểm tra
     * @param {*} dist danh sách tài khoản dạng 5111;1211;111;,,,
     * HTHIEP 26.07.2022
     */
    checkValidAccount(source, dist) {
      //Nếu source null và dist null thì return đúng luôn
      if (!source && !dist) {
        return true;
      }

      //Th1: check xem nguồn hiện tại nằm trong dist không, nằm trong thì return luôn
      if (source && dist && dist.split(';').find(x => x && x.trim() === source)) {
        return true;
      }

      //Th2: Lấy con chi tiết nhất để check thử
      if (source && dist && dist.split(';').find(x => x && source.startsWith(x.trim()))) {
        return true;
      }
      return false;
    },

    /**
     * Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * HTHIEP 11.07.2022
     */
    getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return this.gridDetailParallel.columns;
    },
    /**
     * Set dữ liệu hạch toán đồng thời
     * @param {*} data
     * HTHIEP 08.07.2022
     */
    async setParallelData(data) {
      const me = this;
      //show mask
      this.gridDetailParallel.showMask();
      if (!this.model.Parallels) {
        this.model.Parallels = [];
      }
      let originData = _.cloneDeep(this.model.Parallels);
      let parallels = originData.filter(x => x.state !== me.$ms.constant.ModelState.Empty) || [];

      if (parallels && parallels.length > 0) {
        //Update state delete
        parallels.forEach(x => {
          x.state = me.$ms.constant.ModelState.Delete;
        });
      }
      //Nếu có data thì gán data có state insert ngược lại gán data có state delete
      if (data && data.length > 0) {
        //Update state insert
        data.forEach(x => {
          x.state = me.$ms.constant.ModelState.Insert;
          //TVDAT 03/08/2022: Bổ sung thêm property sort_order
          x.sort_order = null;
        });
        this.model.Parallels = [...parallels, ...data];
      } else {
        this.model.Parallels = parallels;
      }
      return null;
    },
    /**
     * Lấy thông tin budgetSource hiện tại, check xem store có không, nếu có thì lấy luôn ở store, không có thì call db
     * HTHIEP 11.07.2022
     */
    async getBudgetSource() {
      //Check trong store => đoạn này chỉ làm khi data ở store trả full, paging thì call thằng api luôn
      const items = this.$store.state[ModuleBudgetSource].items;
      if (items && items.length > 0) {
        return items;
      }
      return await this.$store.dispatch(`${ModuleBudgetSource}/loadTree`, {
        columns: 'budget_source_id,group_property_type,parent_id,is_parent',
      });
    },

    /**
     * Lấy danh sách rule hạch toán đồng thời
     * HTHIEP 12.07.2022
     */
    async getAccountParallelRule() {
      //Check xem chứng từ hiện tại thuộc bảng kê trong list hay không, nếu bảng kê trong list thì lấy ra rule hạch toán đồng thời riêng?
      let module = ModuleAccountParallelRule;
      if (this.getVouchersForParallel().find(x => x === this.refType)) {
        module = ModuleSysAccountParallelVoucherListRule;
      }
      //Check trong store => đoạn này chỉ làm khi data ở store trả full, paging thì call thằng api luôn
      const items = this.$store.state[module].items;
      if (items && items.length > 0) {
        return items;
      }
      return await this.$store.dispatch(`${module}/getFullList`, {
        columns: '*',
      });
    },

    /**
     * Lấy ra danh sách bảng kê hạch toán đồng thời theo rule bảng kê
     * HTHIEP 29.07.2022
     */
    getVouchersForParallel() {
      return [
        this.$ms.constant.RefType.BUVoucherListPlanned,
        this.$ms.constant.RefType.BUVoucherListNotPlanned,
        this.$ms.constant.RefType.BUVoucherListReceipExpense,
      ];
    },

    /**
     * Lấy ra danh sách các chứng từ không cần kiểm tra định khoản hợp lẹ
     * NXCHIEN 29.09.2022
     */
    getVoucherNotCheckBusiness() {
      return [
        this.$ms.constant.RefType.BUPlanWithdrawDeposit,
        this.$ms.constant.RefType.BUPlanWithdrawCash,
        this.$ms.constant.RefType.BUPlanWithdrawTransfer,
        this.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
        this.$ms.constant.RefType.BUCommitmentRequest,
        this.$ms.constant.RefType.SUTransfer,
        this.$ms.constant.RefType.SUDecrement,
      ];
    },

    /**
     * Kiểm tra xem dòng hạch toán hiện tại có map với hạch toán đã sinh theo rule k => base sẽ check các thông tin cơ bản
     * Đoạn này dev override về tự check theo điều kiện nếu khác mặc định
     * HTHIEP 12.07.2022
     * Modified by NVTUAN1 02.08.2022: Check thêm các trường chung: chương, khoản, mục, tiểu mục, tiết tiểu mục, chương trình mục tiêu dự án, phí lệ phí, đề tài
     * Modified by NVTUAN1 26.06.2024: Check chênh lệch thêm trường nhiệm vụ đã được bổ sung từ trước ở file excel chênh lệch nhưng chưa xử lý check chênh lệch ở đây
     */
    hasItemMapParallelForRule(parallels, item) {
      const me = this;

      //Một số trường đang so sánh == để khi rơi vào trường hợp so sánh undefined với null vẫn đúng
      let itemValid = parallels.find(
        x =>
          x[me.$ms.constant.ColumnCommon.orgRefDetailId] &&
          item[me.$ms.constant.ColumnCommon.orgRefDetailId] &&
          x[me.$ms.constant.ColumnCommon.orgRefDetailId].toLowerCase() ===
            item[me.$ms.constant.ColumnCommon.orgRefDetailId].toLowerCase() &&
          x[me.$ms.constant.ColumnCommon.amount] == item[me.$ms.constant.ColumnCommon.amount] &&
          x[me.$ms.constant.ColumnCommon.amountOc] == item[me.$ms.constant.ColumnCommon.amountOc] &&
          x[me.$ms.constant.ColumnCommon.budgetSourceId] &&
          item[me.$ms.constant.ColumnCommon.budgetSourceId] &&
          x[me.$ms.constant.ColumnCommon.budgetSourceId].toLowerCase() ===
            item[me.$ms.constant.ColumnCommon.budgetSourceId].toLowerCase() &&
          x[me.$ms.constant.ColumnCommon.cashWithdrawTypeId] ===
            item[me.$ms.constant.ColumnCommon.cashWithdrawTypeId] &&
          x[me.$ms.constant.ColumnCommon.methodDistributeType] ===
            item[me.$ms.constant.ColumnCommon.methodDistributeType] &&
          ((!x[me.$ms.constant.ColumnCommon.debitAccount] && !item[me.$ms.constant.ColumnCommon.debitAccount]) ||
            x[me.$ms.constant.ColumnCommon.debitAccount] === item[me.$ms.constant.ColumnCommon.debitAccount]) &&
          ((!x[me.$ms.constant.ColumnCommon.creditAccount] && !item[me.$ms.constant.ColumnCommon.creditAccount]) ||
            x[me.$ms.constant.ColumnCommon.creditAccount] === item[me.$ms.constant.ColumnCommon.creditAccount]) &&
          x[me.$ms.constant.ColumnCommon.budgetChapterCode] == item[me.$ms.constant.ColumnCommon.budgetChapterCode] &&
          x[me.$ms.constant.ColumnCommon.budgetSubKindItemCode] ==
            item[me.$ms.constant.ColumnCommon.budgetSubKindItemCode] &&
          x[me.$ms.constant.ColumnCommon.budgetItemCode] == item[me.$ms.constant.ColumnCommon.budgetItemCode] &&
          x[me.$ms.constant.ColumnCommon.budgetSubItemCode] == item[me.$ms.constant.ColumnCommon.budgetSubItemCode] &&
          x[me.$ms.constant.ColumnCommon.budgetDetailItemCode] ==
            item[me.$ms.constant.ColumnCommon.budgetDetailItemCode] &&
          x[me.$ms.constant.ColumnCommon.projectCode] == item[me.$ms.constant.ColumnCommon.projectCode] &&
          x[me.$ms.constant.ColumnCommon.topicCode] == item[me.$ms.constant.ColumnCommon.topicCode] &&
          x[me.$ms.constant.ColumnCommon.budgetFeesCode] == item[me.$ms.constant.ColumnCommon.budgetFeesCode] &&
          x[me.$ms.constant.ColumnCommon.taskCode] == item[me.$ms.constant.ColumnCommon.taskCode],
      );
      if (itemValid) {
        return true;
      }
      return false;
    },
    /**
     * Dữ liệu bảng kê sinh hạch toán đồng thời: Chỉ bảng kê mới chạy qua hàm này
     * NXCHIEN 01.08.2022
     */
    getDataVoucherList(voucherList) {
      const me = this;
      const paymentKey = me.$store.state[me.module]?._config?.field?.paymentKey;
      if (paymentKey) {
        return voucherList.filter(x => x[paymentKey]);
      }
      // Nếu không thấy key thì mặc định cho []
      return [];
    },
    /**
     * Sự kiện duyệt
     * NXCHIEN 03.07.2022
     * Modified by NVTUAN1 30.08.2022: Thay đổi cơ chế duyệt. Chỉ duyệt chứng từ cùng ref_type với chứng từ đang mở
     */
    onApproveAction() {
      const me = this;
      let formApproveName = me._formParam.formApproveName || me.formApproveName;

      //Nếu không có tên form duyệt trong _formParam thì lấy từ sessionStorage
      if (!formApproveName) {
        formApproveName = me.$ms.commonFn.getSessionStorage('formApproveName');
      }

      if (!formApproveName) {
        console.error('Thiếu cấu hình formApproveName');
        return;
      }

      //Clone để tránh reference
      let model = {...me.model};

      popupUtil.show(formApproveName, {
        model: model,
        formApproveName: formApproveName,
        options: {
          //Load dữ liệu chứng từ được chọn
          submitView: data => {
            me.view({
              id: data.ref_id,
              mode: me.$ms.constant.FormState.View,
            });
          },
        },
      });
    },

    /**
     * Lấy ra tất cả tài khoản trong các grid
     * Tham số truyền các ref của các grid muốn lấy ra
     * NXCHIEN 12.07.2022
     */
    getAllAccount(...args) {
      //lấy ra các tài khoản có trong grid detail

      let me = this;
      let data = args.filter(grd => grd).reduce((arr, grd) => [...arr, ...(me.$refs[grd]?.dataView || [])], []);

      let accountFilter = [
        me.$ms.constant.ColumnCommon.debitAccount,
        me.$ms.constant.ColumnCommon.creditAccount,
        me.$ms.constant.ColumnCommon.taxAccount,
        me.$ms.constant.ColumnCommon.cogsAccount,
        me.$ms.constant.ColumnCommon.inventoryAccount,
      ];
      var accounts = me.$ms.commonFn.distinct(
        data.reduce((o, x) => [...o, ...accountFilter.reduce((t, y) => [...t, x[y]], [])], []),
      );

      return accounts.filter(x => x);
    },

    /**
     * Lấy ra tất cả các mã hàng và mã kho trên grid
     * Tham số truyền các ref của các grid muốn lấy ra
     * NTLOC 12.08.2022
     */
    getAllInventoryItem(...args) {
      // lấy ra các mã hàng có trong grid detail
      let me = this;
      // lấy ra dòng dữ liệu đnag active
      let data = me.$refs['refDetail'].rowSelected;
      var listInventory = [];
      if (data.selected) {
        if (data) {
          if (data.inventory_item_id) {
            var objInventory = {
              InventoryItemId: data.inventory_item_id,
              InventoryItemCode: data.inventory_item_code,
              StockCode: data.stock_code || data.from_stock_code,
              StockID: data.stock_id || data.from_stock_id,
              LotNo: data.lot_no,
              ExpireDate: data.expiry_date,
            };
            listInventory.push(objInventory);
          }
        }
      }

      return listInventory;
    },

    /**
     * Validate chi tiết theo tài khoản
     * NXCHIEN 12.07.2022
     */
    async validateDetail() {
      const me = this;
      // xử lý lấy ra các trường chi tiết theo để validate
      // lấy ra tất cả tài khoản trên các grid, cần thêm Tk thì bổ sung thêm vào
      let accounts = me.getAllAccount('refDetail', 'refDetailParallel', 'refDetailOther');
      // lấy dữ liệu chi tiết theo
      let payload = {
        columns:
          'account_number,is_detail_by_budget_source,is_detail_by_budget_chapter,is_detail_by_budget_kind_item,is_detail_by_budget_item,is_detail_by_budget_sub_item,is_detail_by_method_distribute,is_detail_by_accounting_object,is_detail_by_activity,is_detail_by_project,is_detail_by_inventory_item,is_detail_by_fund,is_detail_by_bank_account,is_detail_by_contract,is_detail_by_task',
        // ,is_detail_by_fixed_asset,is_detail_by_project_activity,is_detail_by_investor,is_detail_by_supply,
        sort: 'account_number',
        filter: JSON.stringify([
          {
            Field: 'account_number',
            Operator: 'IN',
            Value: accounts,
          },
        ]),
        take: 1000,
      };

      // Map từ chi tiết sang tên các columns
      let mapData = me.getMapDetailName();
      let res = await accountAPI.getComboboxPaging(payload);

      // xử lý build mes
      if (res && res.length) {
        // lấy dữ liệu tất cả grid
        let data = me.getSummaryDataGrid('refDetail', 'refDetailParallel', 'refDetailOther');
        let arr = res.map(x => {
          let acc = x.account_number;
          delete x.account_number;
          return {
            key: acc,
            value: Object.keys(x).filter(i => x[i]),
          };
        });

        // map từ chi tiết theo sang dataField của các columns
        let mapField = me.getMapField();

        var invalid = me.getResultGrid(arr, mapField, data, mapData);
      }

      return invalid;
    },

    /**
     * Trả về kết quả Field chi tiết theo + field chưa nhập[]
     * @param {*} mapField: chi tiết theo => dataField, data: dữ liệu trên các grid
     * NXCHIEN 25.08.2022
     */
    getResultGrid(arr, mapField, data, mapData) {
      const me = this;
      return arr
        .filter(x => x.value.length)
        .map(x => {
          let keys = x.value;
          let fields = keys.filter(key => {
            let objMapfield = mapField.find(t => t.field == key);
            if (objMapfield && objMapfield.mapField) {
              let field = objMapfield.mapField;
              if (objMapfield.isCheckAll) {
                return (
                  data.filter(o => o.debit_account == x.key || o.credit_account == x.key).some(row => !row[field]) &&
                  !me.model[field]
                );
              } else {
                return data.filter(o => o.debit_account == x.key || o.credit_account == x.key).some(row => !row[field]);
              }
            } else {
              return false;
            }
          });

          return {
            key: x.key,
            field: fields,
            mapField: mapField
              .filter(t => fields.includes(t.field))
              .map(t => {
                return {
                  mapField: t.mapField,
                  isCheckAll: t.isCheckAll ? t.isCheckAll : false,
                };
              }),
            build: fields.map(t => mapData[t]),
          };
        })
        .filter(x => x.field.length);
    },

    /**
     * Danh sách máp từ chi tiết theo sang các field
     * NXCHIEN 13.07.2022
     */
    getMapField() {
      const me = this;

      let data = [
        {field: 'is_detail_by_budget_source', mapField: 'budget_source_name'},
        {
          field: 'is_detail_by_budget_chapter',
          mapField: 'budget_chapter_code',
        },
        {
          field: 'is_detail_by_budget_kind_item',
          mapField: 'budget_sub_kind_item_code',
        },
        {field: 'is_detail_by_budget_item', mapField: 'budget_item_code'},
        {
          field: 'is_detail_by_budget_sub_item',
          mapField: 'budget_sub_item_code',
        },
        {
          field: 'is_detail_by_method_distribute',
          mapField: 'method_distribute_name',
        },
        {
          field: 'is_detail_by_accounting_object',
          mapField: 'accounting_object_code',
        },
        {field: 'is_detail_by_activity', mapField: 'activity_name'},
        {field: 'is_detail_by_project', mapField: 'project_code'},
        {field: 'is_detail_by_inventory_item', mapField: 'stock_code'},
        {field: 'is_detail_by_fund', mapField: 'fund_code'},
        {
          field: 'is_detail_by_bank_account',
          mapField: 'bank_account',
          isCheckAll: true,
        },
        {field: 'is_detail_by_contract', mapField: 'contract_no'},
        {field: 'is_detail_by_task', mapField: 'task_code'},
      ];

      me.customMapField(data);

      return data;
    },

    /**
     * Thực hiện mapping lại các mapField nếu tên trường khác với mặc định
     * NVTUAN1 19.08.2022
     */
    customMapField(data) {},

    /**
     * Map từ các field chi tiết theo sang tên các columns
     * NXCHIEN 13.07.2022
     */
    getMapDetailName() {
      return {
        is_detail_by_budget_source: 'Nguồn',
        is_detail_by_budget_chapter: 'Chương',
        is_detail_by_budget_kind_item: 'Loại, Khoản',
        is_detail_by_budget_item: 'Mục',
        is_detail_by_budget_sub_item: 'Tiểu mục',
        is_detail_by_method_distribute: 'Hình thức cấp phát',
        is_detail_by_accounting_object: 'Đối tượng',
        is_detail_by_activity: 'Hoạt động',
        is_detail_by_project: 'Chương trình mục tiêu, dự án',
        // is_detail_by_inventory_item: 'VTHH, CCDC tồn kho',
        is_detail_by_fund: 'Loại quỹ',
        is_detail_by_bank_account: 'TK Ngân hàng, Kho bạc',
        is_detail_by_contract: 'Hợp đồng',
        is_detail_by_inventory_item: 'Mã Kho',
        is_detail_by_task: 'Nhiệm vụ',
      };
    },

    /**
     * Lấy dữ liệu của các grid
     * NXCHIEN 13.07.2022
     */
    getSummaryDataGrid(...args) {
      let me = this;
      return args.filter(grd => grd).reduce((arr, grd) => [...arr, ...(me.$refs[grd]?.dataView || [])], []);
    },

    /**
     * Click mở form copy chứng từ
     * NCPHUOC 19/07/2022
     */
    clickCopyVoucher() {
      const me = this;
      if (me.refType) {
        popupUtil.show('CopyVoucherPopup', {
          options: {
            isHasTaxGrid: !!this.getTaxKeyModel(),
            refType: me.refType,
            submit: me.bindingCopyVoucher.bind(me),
            extendColumnForm: me.extendColumnsCopyVoucher(),
            columns: me.gridDetail?.columnFull?.map(x => x.dataField),
          },
        });
      }
    },

    /**
     * Binding dữ liệu xuống grid sau khi thực hiện copy chứng từ
     * @param {*} ls Danh sách được chọn trên form copy chứng từ
     * NCPHUOC 19/07/2022
     */
    bindingCopyVoucher(ls, listTaxDetail) {
      this.bindingTaxGrid(listTaxDetail);
      if (Array.isArray(ls) && ls.length > 0 && this._gridDetails) {
        const refKeyGridDetail = Object.keys(this._gridDetails)[0];
        if (refKeyGridDetail) {
          ls.forEach(item => {
            item.state = this.$ms.constant.ModelState.Insert;
            item = this.mappingCopyVoucher(item);
          });
          this.model[refKeyGridDetail].push(...ls);
          this.model[refKeyGridDetail] = this.model[refKeyGridDetail].filter(
            x => x.state !== this.$ms.constant.ModelState.Empty,
          );
        }
      }
    },

    /**
     * binding dữ liệu của grid thuế
     * @param {*} ls  Danh sách được chọn trên form copy chứng từ
     * @param {*} listTaxDetail danh sách detail thuế
     */
    bindingTaxGrid(listTaxDetail) {
      const taxModelKey = this.getTaxKeyModel();
      if (!taxModelKey || !listTaxDetail?.length) {
        return;
      }

      listTaxDetail.forEach(x => {
        this.mappingCopyTaxVoucher(x);
      });

      this.model[taxModelKey].push(...listTaxDetail);
      this.model[taxModelKey] = this.model[taxModelKey].filter(x => x.state != this.$ms.constant.ModelState.Empty);
    },

    getTaxKeyModel() {
      return null;
    },

    /**
     * @override lại hàm này để mapping theo đúng bảng
     * NCPHUOC 19/07/2022
     * Modified by NVTUAN1: Xử lý tính lại quy đổi khi sao chép chọn Loại tiền khác VND
     */
    mappingCopyVoucher(itemCopy) {
      const me = this;

      if (me.model && me.model.currency_code && me.model.currency_code == me.$t('i18nEnum.Currency.VND')) {
        itemCopy.amount_oc = itemCopy.amount_oc || itemCopy.amount;
      }

      if (me.model && me.model.currency_code && me.model.currency_code != me.$t('i18nEnum.Currency.VND')) {
        itemCopy.amount =
          me?.$ms?.commonFn?.roundDecimalDbOption(
            me?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
            itemCopy.amount_oc * me.model.exchange_rate,
          ) ||
          itemCopy.amount_oc * me.model.exchange_rate ||
          0;
      }
      //Xóa ref_id và ref_detail_id tránh lỗi duplicate id

      delete itemCopy.ref_id;
      delete itemCopy.ref_detail_id;
      return itemCopy;
    },

    /**
     * override lại hàm này để xử lý dòng thuế trước khi binding
     * @param {*} itemCopy
     * @returns
     */
    mappingCopyTaxVoucher(itemCopy) {
      delete itemCopy.ref_id;
      delete itemCopy.ref_detail_id;
      return itemCopy;
    },

    /**
     * @override lại hàm này nếu muốn thêm cột
     * NCPHUOC 04/08/2022
     */
    extendColumnsCopyVoucher() {
      return ['project_code', 'activity_name', 'org_ref_date', 'org_ref_no', 'amount'];
    },

    /**
     * Set validate error vào trong grid
     * NCPHUOC 08/09/2022
     */
    setBusinessValidateGrid(businessErrors) {
      //TODO => cấu trúc tương tự như này
      // businessErrors = [
      //   { colIndex: 0, rowIndex: 1, errorMessage: 'Tôi là ai' }
      // ];

      if (typeof this.gridDetail.addBusinessValidate === 'function') {
        this.gridDetail.addBusinessValidate(businessErrors);
      }
    },

    /**
     * Xử lý khi cất thành công
     */
    saveSuccess(result, param, action) {
      const me = this;

      me.super('saveSuccess', baseDetailPopup, result, param, action);
    },

    /**
     * Override base
     * Lưu xong đóng form
     * @param {*} result
     * @param {*} param
     * NVTUAN1 01.03.2024
     */
    afterSubmitModeSave(result, param) {
      const me = this;
      me.saveAndClose = true;

      // NXCHIEN 17.01.2022: tránh trường hợp ghi sổ ko thánh công thì RecordVersion chưa được cập nhật
      me.model = _.cloneDeep(result);
      // gán lại oldDataitem
      me.bindingDetail(me.model);

      me.setFormMode(me.$ms.constant.FormState.View);

      this.$nextTick(() => {
        me.setOldDataItem();
      });

      //NVTUAN1 01.03.2024: Cất xong đóng form nếu thỏa mãn một trong các điều kiện sau
      // + Thiết lập tùy chọn có tick Lưu không ghi sổ
      // + Không có kết quả trả về
      // + Kết quả trả về không có ref_id
      // + Kết quả trả về không có ref_type
      // + Kết quả trả về có ref_type nằm trong nhóm chứng từ không có chức năng ghi sổ
      if (
        (me.dbOptions && !me.dbOptions.PostAfterSave) ||
        !result?.ref_id ||
        !result?.ref_type ||
        me.$ms.constant.FixValue.ListVoucherNotPosted.includes(result.ref_type)
      ) {
        me.hide();
      }
    },

    /**
     * Override base
     * Thực hiện các công việc sau khi cất thành công
     * @param {*} result
     * NVTUAN1 10.01.2024
     * Modified by NVTUAN1 29.02.2024: Bốc code xử lý cho chứng từ của hàm này từ baseDetailPopup xuống baseDetailVoucher cho đúng thiết kế base
     */
    async afterSaveSuccess(result) {
      const me = this;
      //NVTUAN1 29.02.2024: Cất xong ghi sổ nếu thỏa mãn tất cả điều kiệu sau
      // + User có quyền ghi sổ
      // + Thiết lập tùy chọn có tick Lưu đồng thời ghi sổ
      // + Kết quả trả về có ref_id, ref_type và ref_type không nằm trong nhóm chứng từ không có chức năng ghi sổ

      let checkPermission = me.checkActionPermission(me.$ms.constant.Permission.Posted);

      if (
        checkPermission &&
        me.dbOptions?.PostAfterSave &&
        result?.ref_id &&
        result?.ref_type &&
        !me.$ms.constant.FixValue.ListVoucherNotPosted.includes(result.ref_type)
      ) {
        //Thực hiện validate đang bảo trì dữ liệu trước khi thực hiện chức năng
        let isValidateMaintain = await maintainDatabaseFn.validateMaintainDatabase(
          me.$ms.constant.Command.Posted,
          result,
        );
        if (!isValidateMaintain) {
          return;
        }

        me.actionPosted(result);
      }
      // Nếu không phải sửa nhanh chứng từ thì mới show toast Cất thành công
      else if (!me.isQuickEditVoucher) {
        me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));
      }
    },

    /**
     * Tách hàm để xử lý ghi sổ sau khi lưu
     * NXCHIEN 28.07.2022
     * Modified by NVTUAN1 10.01.2024: Refactor code hàm ghi sổ chỉ thực hiện ghi sổ chứ không làm gì khác
     * Modified by NVTUAN1 29.02.2024: Chuyển hàm này từ baseDetailPopup xuống baseDetailVoucher cho đúng thiết kế base
     */
    actionPosted(result) {
      const me = this;
      me.onPosted(result, false, null, true);
    },

    /**
     * check ref_type chứng từ call monitor
     */
    checkRefTypeVoucherCallMonitor(refType) {
      let me = this;
      if (refType) {
        me.callAnalysisMonitor();
      }
    },

    /**
     * Xử lý gửi dữ liệu lên monitor
     * @param {*} result
     * @param {*} action
     */
    async callAnalysisMonitor() {
      let me = this;
      let context = JSON.parse(localStorage.getItem('mimosa_vuex')).context.Context,
        param = {
          ApplicationCode: 'MMO',
          SubAppCode: 'MMO',
          SubSystemCode: me.subSystemCode,
          SubSystemName: me.subSystemCode,
          TypeLevel: 0,
          UnitName: null,
          Url: window.location.href,
          User: context.FullName,
          UserID: context.UserID,
          Action: 'Change',
          ActionDetail: 'Save',
          TenantID: context.TenantId,
          TenantName: context.TenantName,
          Role: null,
          BudgetCode: context.BudgetCode,
          TaxCode: null,
          ActionDate: new Date(),
          DatabaseId: context.DatabaseId,
          DatabaseName: context.DatabaseName,
        };

      let config = {
        url: window._monitor.analysis,
        data: JSON.stringify(JSON.stringify(param)),
      };

      await httpClient.postAsync(config);
    },

    /**
     * Hướng dẫn
     */
    guide(e, disable) {
      if (!disable) {
        this.showStep = true;
      }
    },

    /**
     * Override lại hàm bindData
     * NHANH3 18.04.2023
     */
    bindData(data) {
      this.super('bindData', baseDetailPopup, data);
      this.getTitleVoucher();
    },

    /**
     * Hàm load dữ liệu combo filter trên header
     * nvtoan2 13/08/2023
     */
    loadComboboxHeaderData(cbColumn, gridCol, queryMode) {
      const me = this;
      if (queryMode != 'remote') {
        let col = me.originColumns?.find(x => x.dataField == gridCol.dataField),
          data = me.getDataFilterComboHeader() ?? me.gridDetail?.dataView,
          dataField = gridCol.dataField;
        if (gridCol?.enum) {
          col = me.originColumns?.find(x => x.enum == gridCol.enum);
          dataField = col?.displayField ?? gridCol?.displayField ?? dataField;
          col.filterValue = Array.from(new Set(data?.filter(obj => obj[dataField])?.map(obj => obj[dataField]))).map(
            uniqueValue => ({[dataField]: uniqueValue}),
          );
        }
        col.filterValue = Array.from(new Set(data?.filter(obj => obj[dataField])?.map(obj => obj[dataField]))).map(
          uniqueValue => ({[dataField]: uniqueValue}),
        );
        if (cbColumn?.sender) {
          cbColumn.sender._allData = col?.filterValue;
        }
      }
    },

    /**
     * Lấy dữ liệu để gán cho combo filter trên header
     * nvtoan2 13/09/2023
     */
    getDataFilterComboHeader() {
      return null;
    },

    /**
     * Lấy tên voucher theo ref_no
     * NHANH3 18.04.2023
     */
    getTitleVoucher() {
      // Nếu mất mạng thì lấy reftype tham số từ formparam trả về
      if (this._formParam?.offlineReady) {
        this.model.ref_type = this._formParam.ref_type;
      }
      if (this.model.ref_type) {
        var key = this.getKeyByValue(this.$ms.constant.RefType, this.model.ref_type);
        this.titleVoucher =
          this.$ms.commonFn.getEnumResource(key, 'RefType') +
          ' ' +
          (this.model.ref_no != null ? this.model.ref_no : '');
        //return this.titleVoucher;
      }
    },

    /**
     * Hàm lấy ra key theo value trong 1 object
     * NHANH3 18.04.2023
     */
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },

    /**
     * @override
     * Hàm callback trước khi đóng form => Gọi hàm callback của chức năng xem chứng từ
     * NVTUAN1 12.05.2023
     */
    callbackBeforeClose() {
      const me = this;
      if (me.options && typeof me.options.callbackFnIncurred === 'function') {
        me.options.callbackFnIncurred();
      }
    },

    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    getDetailParameter(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          if (me.$store.state[me.module]._config.field.key) {
            param.id = defaultData[me.$store.state[me.module]._config.field.key];
          }
          break;
      }

      param.mode = mode;

      me.customDetailParam(param);

      return param;
    },

    /**
     * @override
     * Cho phép dev override lại hàm này để bổ sung thêm param khi show form chi tiết nếu cần
     * @param {*} param
     */
    customDetailParam(param) {},

    /**
     * Hiển thị target link khi xem chứng từ
     * @author NHCUONG 26.06.2023
     */
    showTargetLink(item) {
      // Lấy tên form tùy theo đặc tính từng bản ghi
      let formName = this.getFormDetailName(item?.ref_type || 0);
      if (formName) {
        //kiểm tra phân quyền
        this.checkActionPermissionAlert(this.$ms.constant.Permission.View);
        let param = this.getDetailParameter(formName, this.$ms.constant.FormState.View, item);
        if (param && param.id) {
          let protocol = window.location.protocol;
          let host = window.location.host;
          let link = `${protocol}//${host}/popup/${formName.toLowerCase()}/${param.id}`;
          window.open(link, '_blank').focus();
        }
      }
    },

    /**
     * Hàm xử lý khi chọn sửa nhanh chứng từ
     * lhphong 26.05.2023
     */
    eventQuickEditVoucher() {
      const me = this;
      // Kiểm tra có quyền ghi sổ không
      var checkPermission = me.checkActionPermission(me.$ms.constant.Permission.Posted);
      if (checkPermission) {
        const {pushTrans} = collectionMonitor();

        pushTrans(me.$ms.constant.Command.Edit, 'Sửa nhanh chứng từ', 'QuickEditVoucher');
        me.isQuickEditVoucher = true;
      }
    },

    /**
     * Lấy dữ liệu trên form
     * */
    getModelDataDetail() {
      return this.model;
    },
  },
});
